import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
  MenuItem,
  RadioGroup,
  Radio,
  FormControlLabel,
  InputAdornment,
  Alert,
  CircularProgress,
  Backdrop,
  ListItemText,
  Grid,
  Paper,
  FormHelperText,
} from '@mui/material';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { API, graphqlOperation } from 'aws-amplify';
import AddIcon from '@mui/icons-material/Add';
import SettingsIcon from '@mui/icons-material/Settings';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { display } from '../../redux/reducers/sidebar';
import { useLocation } from 'react-router-dom';
import TeaxtareaField from '../../components/formElements/TeaxtareaField';
import PercentIcon from '@mui/icons-material/Percent';

import {
  createTransactionAttachment,
  createTransactionRelation,
  createTransactionWithSpecificTime,
  createTransactionWithSpecificTimev2,
  deleteTransactionMaster,
  getLastUsedBankOrCashAccount,
  getMinMaxInvoiceDate,
} from '../../graphql';

import {
  getTransactionMaster,
  getCompanyCodeTranslation,
  getAccountBalance,
  getTransactionTDSDetails,
  listTransactionMasterv2,
  listPartyInvoicePurchases,
  getLinkedReceipts,
  getTransactionMasterV2,
} from '../../graphql';

import printJS from 'print-js';
import { settingsClose } from '../../redux/reducers/companySkipSave';
import LinkToPurchaseInvoice from '../../components/modals/LinkToPurchaseInvoice';
import { MoneyFormatv3, getWords } from '../../library/MoneyFormat';
import ConfirmCancel from '../../components/modals/confirmCancel';
import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from '../../components/snackBar/snakbar';
import { AccountInput, AccountInputv2 } from '../../components/formElements/AccountInput';
import { uploadToServer } from '../../library/upload';
import { HeadingWithRuler } from '../../components/Ui/Ui';
import PreviewSalesTaxable from '../../components/modals/PreviewSalesTaxable';
import { makeStyles } from '@mui/styles';
import ConfirmExit from '../../components/modals/ConfirmExit';
import { listPartyAndTransactionMastersCustomPyt } from '../../graphql';

import AddBankAccountModal from './Modals/AddBankAccountModal';
import AddAccountModal from './Modals/AddAccountModal';
import MoneyInput from '../../components/formElements/moneyFormatInput';
import Attachment from '../NewFigma/AddCustomer/attachment';
import ToolTipComponent from './Components/ToolTipComponent';
import DraggableAction from '../../components/Buttons/DraggableAction';
import InvoiceCancel from '../../components/modals/InvoiceCancel';
import LinkingTable from '../../components/Table/LinkingTable';
import { useThemes } from '../../components/Theme/theme';
import useSaveShortcut from '../../hooks/useSaveShortcut';
import { setNavigationBlocked } from '../../redux/reducers/controllNavigation';
import { useListGeneralSettingQuery, VoucherSettingsApi } from '../../redux/apis/newVoucherSettings.api';
import NewVoucherSettingsModal from './Modals/newVoucherSettingModal';
import { useCreatePdfMutation } from '../../redux/apis/createPdf.api';
import { dashboardApi } from '../../redux/apis/dashboardApi';
import { baseQueryv2 as baseQuery } from '../../redux/baseQuery';
import { useListAccountMasterv2Query } from '../../redux/apis/accountMaster.api';
import { LedgerTransactionModalv2 } from '../LedgerTransaction';
import dayjs from 'dayjs';
import { fetchAndPrintPDF } from '../../utils/common';
import moment from 'moment';
import API_ENDPOINTS from '../../apiEndpoints';
import SummaryDialog from '../../components/modals/SummaryDialog';
import ItemAttachment from './ItemPage/ItemAttachment';
import CustomTooltip from '../../components/CustomTooltip';
import useSaveShortcutV1 from '../../hooks/useSaveShortcutV1';
import useControlledNavigation from '../../hooks/useControlledNavigation';
import { ReceiptPrint } from '../../library/InvoicePrint';
import CancelUI from '../../components/Ui/CancelUI';
import { updateTitle } from '../../redux/reducers/titleSlice';
import './Components/Invoice.css';
import { CheckVoucherValid } from './Components/CheckVoucherValid';
import { paymentApi, useGetLastUsedBankOrCashAccountQuery, useGetMinMaxInvoiceDateQuery } from '../../features/Payment/api/payment.api';
import { useListCompanyPreferenceQuery } from '../../redux/apis/companyPreference.api';
import { DEFAULT_DATE_FORMAT } from '../../config';

let today = new Date();
let yy = today.getFullYear();
let mm = today.getMonth() + 1;
let dd = today.getDate();

if (dd < 10) dd = '0' + dd;
if (mm < 10) mm = '0' + mm;

const todayDate = yy + '-' + mm + '-' + dd;

const useStyles = makeStyles((theme) => ({
  root: {
    '&.css-1v7lraa-MuiPaper-root': {
      borderRadius: '15px',
    },
  },
  check: {
    '&.css-i4bv87-MuiSvgIcon-root': {
      fontSize: '20px',
      // color: "red",
    },
    color: 'red!important',
  },
  accordionRoot: {
    '&.MuiAccordion-root': {
      boxShadow: 'none',
    },
    '&.MuiAccordionSummary-content': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: '1px solid black',
    },
  },

  accordionSummary: {
    '& .MuiAccordionSummary-expandIconWrapper': {
      backgroundColor: 'lightgrey',
      borderRadius: '50%',
    },
  },
}));
function AddPaymentVoucher({ paidFrom, paidTo, onSaveComplete, method = 'CashPayment' }) {
  console.log(method);
  const { theme } = useThemes();

  // const navigate = useNavigate();
  const navigate = useControlledNavigation();
  if (!onSaveComplete) {
    onSaveComplete = () => navigate('/paymententries', { force: true });
  }
  const dispatch = useDispatch();
  const imageRef = useRef();
  dispatch(display());
  let location = useLocation();

  const params = location.state || {
    id: parseInt(new URLSearchParams(window.location.search).get('transaction')),
    view: parseInt(new URLSearchParams(window.location.search).get('transaction')) ? true : false,
    // pdflink: new URLSearchParams(window.location.search).get("pdflink") || "",
  };

  const { Enable_ItemWiseEntry } = useSelector((state) => state.paymentSettingsReducer);
  // let [f_newAccount,setF_newAccount]=useState("")
  const [backdropOpen, setBackdropOpen] = useState(true);
  const [tdsFlag, setTdsFlag] = useState(false);
  // const [accountName, setAccountName] = useState([
  //   {
  //     label: params.name ? params.name : "",
  //     value: params.partyID ? params.partyID : "",
  //     AccountTypeFlag: params.partyID ? 2 : "",
  //   },
  // ]);
  const [paymentFlag, setPaymentFlag] = useState(true);
  // const [cashAccount, setCashAccount] = useState([]);
  // const [bankAccount, setBankAccount] = useState([]);
  const [initialAttachments, setInitialAttachments] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [currentDocuments, setCurrentDocuments] = useState([]);
  const randomNum = Math.floor(Math.random() * 100 + 1);
  const timeStamp = Math.floor(new Date().getTime() / 1000);
  const randomNumber = randomNum + timeStamp.toString().slice(3, 10);
  const [entries, setEntries] = useState([]);
  const [entryStamp, setEntryStamp] = useState('');
  const [openBankModal, setOpenBankModal] = useState(false);
  const [fromAccountModal, setFromAccountModal] = useState(false);
  const [accountFlag, setAccountFlag] = useState(false);
  const [attachedArr, setAttachedArr] = useState([]);
  const [tdsSection, setTdsSection] = useState([]);
  const [fromBalanceAmount, setFromBalanceAmount] = useState(0);
  const [toBalanceAmount, setToBalanceAmount] = useState(0);
  const [entryData, setEntryData] = useState([]);
  const [linkToInvoiceModal, setLinkToInvoiceModal] = useState(false);
  const [accountID, setAccountID] = useState(0);
  const [accountIDTransaction, setAccountIDTransaction] = useState('');
  const [transArr, setTransArr] = useState('');
  const [linkedData, setLinkedData] = useState([]);
  const [partylist, setPartyList] = useState([]);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [supplierID, setSupplierID] = useState('');
  const [cancelModal, setCancelModal] = useState(false);
  const [generalSettingsFlag, setGeneralSettingsFlag] = useState(-1);
  const [settingsModal, setSettingsModal] = useState(false);
  const [paymentVoucherNos, setPaymentVoucherNos] = useState([]);
  const [accountType, setAccountType] = useState('');
  const [vouchNo, setVouchNo] = useState('');
  const [selelctedGroupId, setSelectedGroupId] = useState('');
  const [newPartyID, setNewPartyID] = useState('');
  const [newPartyName, setNewPartyName] = useState('');
  const [openModalEvent, setOpenModalEvent] = useState(false);
  const [cashAccountObj, setCashAccountObj] = useState();
  const [bankAccountObj, setBankAccountObj] = useState();
  const [serialNos, setSerialNos] = useState([]);
  const [activeVouchers, setActiveVouchers] = useState([]);
  const [tdsID, setTdsID] = useState('');
  const [SummaryData, setSummaryData] = useState({
    open: false,
    description: '',
    lists: [],
    title: '',
  });
  console.log({ setSerialNos });
  console.log(fromBalanceAmount, '}}}}fromBalanceAmount');

  let userPreferece = useSelector((state) => state.userPrefrenceandReducer);
  const { data: companyPreference } = useListCompanyPreferenceQuery();
  const postingDatePref = companyPreference?.find(
    (p) =>
      p.attributetypecd === 'MyPostingDate' &&
      String(p?.additionalvalue ?? '') === String(userPreferece?.financialYear?.financialyearid ?? '')
  );
  const savedPostingDate = postingDatePref?.attributevalue;
  let path = `${userPreferece?.financialYear?.companyid}/${userPreferece?.financialYear?.companybranchid}/${userPreferece?.financialYear?.financialyearid}/`;
  const invalidateAllVoucherSerialNumbers = () => {
    dispatch(VoucherSettingsApi.util.invalidateTags([{ type: 'VoucherSerialNumbers', id: 'ALL' }]));
    dispatch(VoucherSettingsApi.util.invalidateTags([{ type: 'listGeneralSettings', id: 'ALL' }]));
  };
  const [initialState, setInitialState] = useState({
    vouchernumber: '',
    // date:todayDate
    date: '',
    method: method || 'CashPayment',
    paidFrom:
      paidFrom ??
      (method === 'CashPayment'
        ? { label: 'Cash A/c', value: 3, AccountTypeFlag: '' }
        : { label: 'Bank A/c', value: 39, AccountTypeFlag: '' }),
    paidTo: paidTo ?? {
      label: params.name ? params.name : '',
      value: params.partyID ? params.partyID : '',
      AccountTypeFlag: params?.partyID ? 2 : '',
    },
    payableAmount: '',
    TDSManual: 0,
    tds: tdsFlag,
    tdsApplicable: '',
    tdsAmount: '',
    paidAmount: '',
    bankRefNo: '',
    remarks: '',
    attachment: '',
    creditName: '',
    debitName: '',
    seriesVouchers: { label: '', value: '' },
    TDSPercentage: 0,
    Towards: '',
    errorStatus: {
      vouchernumber: false,
      date: false,
      method: false,
      paidFrom: false,
      paidTo: false,
      payableAmount: false,
      tds: false,
      tdsApplicable: false,
      tdsAmount: false,
      paidAmount: false,
      bankRefNo: false,
      remarks: false,
      attachment: false,
      seriesVouchers: false,
      TDSPercentage: false,
      narration: false,
    },
    errorFields: {
      vouchernumber: '',
      date: '',
      method: '',
      paidFrom: '',
      paidTo: '',
      payableAmount: '',
      tds: '',
      tdsApplicable: '',
      tdsAmount: '',
      paidAmount: '',
      bankRefNo: '',
      remarks: '',
      attachment: '',
      seriesVouchers: '',
      TDSPercentage: '',
      narration: '',
    },
  });

  console.log(initialState, 'initial state=====>');
  const [state, setState] = useState({ ...initialState });
  const [viewMode, setViewMode] = useState(false);
  const [previewPaymentModal, setPreviewPaymentModal] = useState(false);
  const [currentPaymentFlag, setCurrentPaymentFlag] = useState(false);
  const [currentBankRefNo, setCurrentBankRefNo] = useState('');
  const [cancelModalStatus, setCancelModalStatus] = useState(false);
  const [itemData, setItemData] = useState({});
  const [deleteItemModal, setDeleteItemModal] = useState(false);
  // console.log(state,"state====>")

  const { saveSkipStatus } = useSelector((state) => state.companySipSaveReducer);
  useEffect(() => {
    if (saveSkipStatus == false) {
      dispatch(settingsClose());
      navigate('/companysetup');
    }
    setAttachments([]);
    if (imageRef.current) {
      imageRef.current.value = '';
    }
  }, []);

  const companyDetail = useSelector((state) => state?.companyReducer.companyDetails);

  useEffect(() => {
    setCompanyDetails(companyDetail);
    return () => {};
  }, [companyDetail]);

  function handleKeyDown(e) {
    if ((e.key === 'Tab' || e.key === 'Enter') && state?.paidTo?.label === '') {
      e.stopPropagation();
      e.preventDefault();
      setState((prev) => ({
        ...prev,
        errorStatus: {
          ...prev.errorStatus,
          paidTo: true,
        },
        errorFields: {
          ...prev.errorFields,
          paidTo: ' Paid To Field Is required',
        },
      }));
    }
  }

  async function getTdsDetails() {
    setBackdropOpen(true);
    const res = await API.graphql(graphqlOperation(getCompanyCodeTranslation, { codetype: '1' }));

    if (res.data.getCompanyCodeTranslation !== null) {
      let tdsArr = res?.data?.getCompanyCodeTranslation.map((element) => {
        return {
          option: `${element.codetext} (${element.codevalue}%)`,
          value: `${element.codevalue}`,
          section: element.codeorder,
        };
      });
      setTdsSection(tdsArr);
    }
    setBackdropOpen(false);
  }
  let url = path + `Invoices/Payments/Ledgerx_Payment_${state.vouchernumber}.pdf`;
  let uri = `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${url}`;
  console.log({ state });
  // const [LastBankAccount, setLastBankAccount] = useState();
  // const [lastCashAccount, setLastCashAccount] = useState();
  const { data: LastBankCashAccounts, isFetching: LoadingLastAccount } = useGetLastUsedBankOrCashAccountQuery({
    transactiontypecd: 'payment',
  });
  const { LastBankAccount, lastCashAccount } = LastBankCashAccounts || {};
  const [createPdf, progress] = useCreatePdfMutation();

  // const fetchLastBankVoucher = async () => {
  //   setLoadingLastAccount(true);
  //   try {
  //     const response = await API.graphql(
  //       graphqlOperation(getLastUsedBankOrCashAccount, {
  //         transactiontypecd: 'payment',
  //         rowfrom: 0,
  //         limitno: 1,
  //         columnname: 'transactionid',
  //         ordertype: 'desc',
  //         searchmode: 1,
  //         searcharray: JSON.stringify([{ bank: '' }]),
  //       })
  //     );

  //     const lastCashAccountRes = await API.graphql(
  //       graphqlOperation(getLastUsedBankOrCashAccount, {
  //         transactiontypecd: 'payment',
  //         rowfrom: 0,
  //         limitno: 1,
  //         columnname: 'transactionid',
  //         ordertype: 'desc',
  //         searchmode: 1,
  //         searcharray: JSON.stringify([{ cash: '' }]),
  //       })
  //     );

  //     setLastBankAccount(response.data.getLastUsedBankOrCashAccount[0]?.paidtoaccountid);
  //     setLastCashAccount(lastCashAccountRes.data.getLastUsedBankOrCashAccount[0]?.paidtoaccountid.split(',')?.[0]);
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     setLoadingLastAccount(false);
  //   }
  // };
  // useEffect(() => {
  //   fetchLastBankVoucher();
  //   return () => {};
  // }, []);

  // useEffect(() => {
  //   getAccountMasterData();
  // }, [fromAccountModal, openBankModal]);

  const [lastInvoiceDate, setLastInvoiceDate] = useState('');
  const [firstInvoiceDate, setFirstInvoiceDate] = useState('');
  const [nextInvoiceDate, setNextInvoiceDate] = useState('');
  const [startDate, setStartDate] = useState(10);
  const [endDate, setEndDate] = useState(11);
  const [openingBalanceDate, setOpeningBalanceDate] = useState('');

  function startDateMian(startYearDate) {
    const formattedDate = dayjs.unix(startYearDate).format('YYYY-MM-DD');
    return `${formattedDate}`;
  }

  // async function getMinandMax() {
  //   try {
  //     const res = await API.graphql(
  //       graphqlOperation(getMinMaxInvoiceDate, {
  //         invoicetypecd: 'Payment',
  //         invoiceid: params?.id && !isNaN(params?.id) ? params?.id : 0,
  //       })
  //     );

  //     console.log(res, '*****respo');
  //     setOpeningBalanceDate(res?.data?.getMinMaxInvoiceDate?.openingbalancedate);
  //     if (res?.data?.getMinMaxInvoiceDate !== null) {
  //       if (res?.data?.getMinMaxInvoiceDate?.previnvoicedate !== null) {
  //         setFirstInvoiceDate(res?.data?.getMinMaxInvoiceDate?.previnvoicedate);
  //       } else {
  //         setFirstInvoiceDate(res?.data?.getMinMaxInvoiceDate?.openingbalancedate);
  //         if (params?.id === '' || isNaN(params?.id)) {
  //           if (res?.data?.getMinMaxInvoiceDate?.latestinvoicedate !== null) {
  //             setState((prev) => ({
  //               ...prev,
  //               date: res?.data?.getMinMaxInvoiceDate?.latestinvoicedate,
  //             }));
  //           } else {
  //             if (res?.data?.getMinMaxInvoiceDate?.openingbalancedate !== null) {
  //               setState((prev) => ({
  //                 ...prev,
  //                 date: res?.data?.getMinMaxInvoiceDate?.openingbalancedate,
  //               }));
  //             } else {
  //               const firstDate = startDateMian(userPreferenceAndFY.financialYear.startdate);
  //               setState((prev) => ({
  //                 ...prev,
  //                 date: firstDate,
  //               }));
  //             }
  //           }
  //         }
  //       }
  //       if (res?.data?.getMinMaxInvoiceDate?.nextinvoicedate !== null) {
  //         setNextInvoiceDate(res?.data?.getMinMaxInvoiceDate?.nextinvoicedate);
  //       }
  //       if (res?.data?.getMinMaxInvoiceDate?.latestinvoicedate !== null) {
  //         setLastInvoiceDate(res?.data?.getMinMaxInvoiceDate?.latestinvoicedate);
  //         if (params?.id === '' || isNaN(params?.id)) {
  //           if (res?.data?.getMinMaxInvoiceDate?.latestinvoicedate !== null) {
  //             setState((prev) => ({
  //               ...prev,
  //               date: res?.data?.getMinMaxInvoiceDate?.latestinvoicedate,
  //             }));
  //           } else {
  //             if (res?.data?.getMinMaxInvoiceDate?.openingbalancedate !== null) {
  //               setState((prev) => ({
  //                 ...prev,
  //                 date: res?.data?.getMinMaxInvoiceDate?.openingbalancedate,
  //               }));
  //             }
  //           }
  //         }
  //       } else {
  //         setLastInvoiceDate(res?.data?.getMinMaxInvoiceDate?.openingbalancedate);
  //       }
  //     }
  //   } catch (error) {
  //     console.log('error', error);
  //   }
  // }

  const userPreferenceAndFY = useSelector((state) => state.userPrefrenceandReducer);

  const { data, isLoading: loadingPayment } = useGetMinMaxInvoiceDateQuery({
    invoicetypecd: 'Payment',
    invoiceid: params?.id && !isNaN(params?.id) ? params?.id : 0,
  });

  const openingDate = useMemo(() => {
    const date = savedPostingDate ? moment(savedPostingDate * 1000).format('YYYY-MM-DD') : openingBalanceDate;

    const dateValue = data?.getMinMaxInvoiceDate?.openingbalancedate;

    return dateValue && dateValue !== 'null' ? dateValue : date || startDateMian(userPreferenceAndFY.financialYear.startdate);
  }, [savedPostingDate, openingBalanceDate, data, userPreferenceAndFY, startDateMian]);

  async function fetchOpeningDate() {
    try {
      //LEDX-5160
      const openingBalanceDate = data?.openingBalanceDate ?? null;

      const date = savedPostingDate ? moment(savedPostingDate * 1000).format('YYYY-MM-DD') : openingBalanceDate;

      setState((prev) => ({ ...prev, date }));
      setInitialState((prev) => ({ ...prev, date }));

      // LEDX-5160
    } catch (error) {
      console.error('Error fetching opening date:', error);
    }
  }
  useEffect(() => {
    if (params?.id) {
      if (entryData?.transactionid) {
        fetchOpeningDate();
      }
    } else {
      fetchOpeningDate();
    }
  }, [savedPostingDate, loadingPayment]);

  function handlePaymentDateChanges(value) {
    const startDate = moment(openingDate);
    console.log(startDate, '****startDate');
    const endDate = moment.unix(userPreferece.financialYear.enddate);
    const inputDate = moment(value, 'YYYY-MM-DD', true);
    const errorStartDate = startDate.format(DEFAULT_DATE_FORMAT);
    const errorEndDate = endDate.format(DEFAULT_DATE_FORMAT);
    setState((prev) => ({
      ...prev,
      date: value,
    }));

    if (value === '') {
      setState((prev) => ({
        ...prev,
        errorStatus: {
          ...prev.errorStatus,
          date: true,
        },
        errorFields: {
          ...prev.errorFields,
          date: 'Please select Payment Date',
        },
      }));
      return;
    }

    if (!inputDate.isValid()) {
      return;
    }

    if (!inputDate.isBetween(startDate, endDate, undefined, '[]')) {
      setState((prev) => ({
        ...prev,
        errorStatus: {
          ...prev.errorStatus,
          date: true,
        },
        errorFields: {
          ...prev.errorFields,
          date: `Date must be within ${errorStartDate} and ${errorEndDate}.`,
        },
      }));
    } else {
      setState((prev) => ({
        ...prev,
        errorStatus: {
          ...prev.errorStatus,
          date: false,
        },
        errorFields: {
          ...prev.errorFields,
          date: '',
        },
      }));
    }
  }

  async function getFY() {
    try {
      setStartDate(userPreferenceAndFY.financialYear.startdate);
      setEndDate(userPreferenceAndFY.financialYear.enddate);
    } catch (error) {
      console.log('Error', error);
    }
  }

  useEffect(() => {
    // getMinandMax();
    getFY();
  }, []);

  useEffect(() => {
    if (lastCashAccount && method === 'CashPayment' && !params.id) {
      let acc = AllAccountsListing.find((elem) => elem.value == lastCashAccount);
      console.log({ lastCashAccount, acc, AllAccountsListing });
      if (acc)
        setState((prev) => ({
          ...prev,
          paidFrom: acc?.label
            ? {
                label: acc?.label,
                value: acc?.value,
              }
            : {
                label: '',
                value: '',
              },

          errorFields: {
            ...prev.errorFields,
            method: '',
            paidFrom: '',
          },
        }));
    }
  }, [lastCashAccount]);
  console.log({ state });
  const cancel = async (id, type, voucherNo) => {
    return new Promise(async (resolve, reject) => {
      try {
        saveEditChanges({ toCancel: 1, CancelRemark: state.reason });
      } catch (error) {
        showErrorSnackbar('Something Went Wrong !');
        console.log(error);
      } finally {
        resolve();
      }
    });
  };
  async function deleteEntry(data) {
    try {
      const res = await API.graphql(
        graphqlOperation(deleteTransactionMaster, {
          transactionid: data?.id,
        })
      );
      if (res.data?.deleteTransactionMaster != null) {
        if (data.nav) {
          dispatch(setNavigationBlocked(false));
          navigate(data.nav, { force: true });
        }
        showSuccessSnackbar(`${data.label} Voucher deleted Successfully`);
        dispatch(dashboardApi.util.invalidateTags(['dashboard']));
      } else {
        alert('Item not Deleted.! something went wrong. please try again');
      }
    } catch (error) {
      setBackdropOpen(false);
      console.log(error);
    }
  }

  const { data: generalSettings } = useListGeneralSettingQuery(
    {
      entrytypecd: 'Payment',
      financialyearid: userPreferece?.financialYear?.financialyearid,
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );
  console.log({ generalSettings, userPreferece });
  async function getItemSettings() {
    try {
      let serialNoArr = [];
      let voucherNo = '';
      // const res = await API.graphql(
      //   graphqlOperation(listVoucherSerialNumbers, {
      //     entrytypecd: "Payment",
      //     // InputDate: Math.floor(new Date(todayDate).getTime() / 1000),
      //   })
      // );
      const res = { data: { listVoucherSerialNumbers: generalSettings } };
      console.log(res);
      let nextInvNo = '';
      if (res.data.listVoucherSerialNumbers.length > 0) {
        let settingsArr = res.data.listVoucherSerialNumbers?.map((ele) => {
          if (ele.expiredtimestamp == 0) {
            nextInvNo = ele.nextinvoicenumber;
            return ele;
          }
        });
        if (nextInvNo !== -1) {
          setGeneralSettingsFlag(nextInvNo);
          // const resSerialVouchers = await API.graphql(
          //   graphqlOperation(listVoucherSerialNumbers, {
          //     EntryTypeCD: "Payment",
          //   })
          // );
          let resSerialVouchers = res;
          setActiveVouchers(resSerialVouchers.data.listVoucherSerialNumbers);
          resSerialVouchers.data.listVoucherSerialNumbers.map((ele) => {
            if (ele.serialisactive == 1) {
              serialNoArr.push({
                label: ele.prefix + ele.nextinvoicenumber + ele.suffix,
                value: ele.serialnumber,
              });
              if (ele.serialnumber === serialNoArr?.[0]?.value) {
                voucherNo = ele.prefix + ele.nextinvoicenumber + ele.suffix;
              }
            }
          });
          console.log({ serialNoArr });
          setSerialNos(serialNoArr);
          let temp = {};
          if (!params?.id) {
            temp.vouchernumber = voucherNo;
            // setState((prev) => ({
            //   ...prev,
            //   vouchernumber: voucherNo,
            // }));
          }
          temp.seriesVouchers = {
            label: serialNoArr?.[0]?.label,
            value: serialNoArr?.[0]?.value,
          };
          setState((prev) => ({
            ...prev,
            ...temp,
          }));
          setInitialState((prev) => ({
            ...prev,
            ...temp,
          }));
        } else {
          setGeneralSettingsFlag(-1);
          if (entryData.length == 0) {
            setState((prev) => ({
              ...prev,
              vouchernumber: '',
            }));
            setInitialState((prev) => ({
              ...prev,
              vouchernumber: '',
            }));
          } else {
            setState((prev) => ({
              ...prev,
              vouchernumber: entryData.vouchernumber,
              seriesVouchers: {
                label: '',
                value: '',
              },
            }));
            setInitialState((prev) => ({
              ...prev,
              vouchernumber: entryData.vouchernumber,
              seriesVouchers: {
                label: '',
                value: '',
              },
            }));
          }
        }
      }
    } catch (error) {
      console.log('error', error);
    }
  }
  async function listVoucherNos() {
    try {
      let Arr = [];
      // const res = await API.graphql(
      //   graphqlOperation(listTransactionMasterCustom)
      // );
      const res1 = await API.graphql(graphqlOperation(listPartyAndTransactionMastersCustomPyt));
      if (res1.data.listTransactionMaster.length > 0) {
        res1.data.listTransactionMaster.map((ele) => {
          if (ele.transactiontypecd === 'CashPayment' || ele.transactiontypecd === 'BankPayment') {
            Arr.push(ele);
          }
        });
        setPaymentVoucherNos(Arr);
      }
      let arr = [];
      res1.data.listPartymasters.map((ele) => {
        arr.push({ Name: ele.partylegalname, value: ele.partyid });
      });
      setPartyList(arr);
    } catch (error) {
      console.log('error', error);
    }
  }

  const [isVoucherEditable, setisVoucherEditable] = useState(false);

  const getEntryData = useCallback(async (data) => {
    try {
      setPaymentFlag(true);
      const res = await API.graphql(graphqlOperation(getTransactionMaster, { transactionid: data }));
      if (res.data?.getTransactionMaster) {
        setEntryData(res.data?.getTransactionMaster[0]);
        if (params?.purchaseID) {
          linkReceordPayment(params?.purchaseID, res.data?.getTransactionMaster);
        }
        setisVoucherEditable(
          res.data?.getTransactionMaster?.[0]?.isvouchereditable === 1 || res.data?.getTransactionMaster?.[0]?.serialnumber === ''
        );
      }
    } catch (error) {
      console.error(error);
    }
  }, []);

  const [amountsFromTable, setamountsFromTable] = useState({
    tdsAmount: 0,
    payableAmount: 0,
  });

  function getPaymentDetails() {
    setBackdropOpen(true);
    setVouchNo(entryData?.vouchernumber);
    getTdsTransaction(entryData?.transactionid);
    setCurrentBankRefNo(entryData?.bankreferencenumber);
    setEntryStamp(entryData?.enteredtimestamp);
    let from = new Date(Number(entryData?.entrydate) * 1000);
    let fromyy = from.getFullYear();
    let frommm = from.getMonth() + 1;
    let fromdd = from.getDate();
    let tdsAmount = 0;
    if (fromdd < 10) fromdd = '0' + fromdd;
    if (frommm < 10) frommm = '0' + frommm;

    const fromDate = fromyy + '-' + frommm + '-' + fromdd;
    const remark = entryData.comments?.split('**');
    let pay = '';
    pay = entryData?.transactiontypecd;
    setEntries(entryData?.relatedtransactiondetails);
    setState((prev) => ({
      ...prev,
      vouchernumber: entryData.vouchernumber,
      seriesVouchers: {
        label: entryData?.serialnumber,
        value: entryData?.serialnumber,
      },
      date: fromDate,
      remarks: entryData?.comments?.replace('**', '\n'),
      bankRefNo: entryData?.bankreferencenumber,
      method: pay,
      Towards: entryData.towards || '',
    }));
    console.log({ serialNos });
    setSerialNos((prev) => [
      ...prev.filter((item) => item.value !== entryData?.serialnumber),
      {
        label: entryData?.vouchernumber,
        value: entryData?.vouchernumber,
      },
    ]);
    setInitialState((prev) => ({
      ...prev,
      vouchernumber: entryData?.vouchernumber,
      seriesVouchers: {
        label: entryData?.serialnumber,
        value: entryData?.serialnumber,
      },
      date: fromDate,
      remarks: entryData?.comments?.replace('**', '\n'),
      bankRefNo: entryData?.bankreferencenumber,
      method: pay,
      Towards: entryData.towards || '',
    }));

    if (entryData?.relatedtransactiontdsdetails?.length > 0) {
      entryData?.relatedtransactiontdsdetails?.map((ele, ind) => {
        ele.tdsamount != 0 ? setTdsFlag(true) : setTdsFlag(false);
        tdsAmount = ele.tdsamount;
        setState((prev) => ({
          ...prev,
          tdsAmount: `${ele.tdsamount}`,
          tdsApplicable: `${ele.tdsapplicablecd}`,
          TDSPercentage: ele.tdspercentage,
          TDSManual: ele.tdsmanual,
        }));
        setInitialState((prev) => ({
          ...prev,
          tdsAmount: `${ele.tdsamount}`,
          tdsApplicable: `${ele.tdsapplicablecd}`,
          TDSPercentage: ele.tdspercentage,
          TDSManual: ele.tdsmanual,
        }));
      });
    }
    if (entryData?.relatedtransactionattachment?.length > 0) {
      let items = [];
      entryData?.relatedtransactionattachment.map((item, ind) => {
        items.push({
          slNo: '',
          documentname: item.documentname,
          imagename: item.attachmentname,
          action: '',
          imageurl: item.attachmenturl,
          attachmentid: item.attachmentid,
        });
      });
      setAttachments(items);
      setCurrentDocuments(items);
      setInitialAttachments(items);
    }
    let amounts = 0;
    if (entryData?.relatedtransactiondetails?.length > 0) {
      let fromAccount = { label: '', value: '' };
      let toAccount = { label: '', value: '' };

      pay = entryData?.transactiontypecd;

      entryData?.relatedtransactiondetails
        .sort((a, b) => a.entryordernumber - b.entryordernumber)
        .map((ele) => {
          if (ele.accountid != 21) {
            if (ele.creditamount == 0 && ele.transactiontypecd == 'Debit') {
              AllAccountsListing.map((subele) => {
                if (ele.accountid == subele.value) {
                  toAccount = {
                    label: subele.label,
                    value: subele.value,
                    AccountTypeFlag: subele.AccountTypeFlag,
                  };
                }
              });
              setAccountID(toAccount.value);
              amounts = ele.debitamount;
            } else {
              if (pay === 'CashPayment') {
                AllAccountsListing.map((subele) => {
                  if (ele.accountid == subele.value) {
                    fromAccount = {
                      label: subele.label,
                      value: subele.value,
                      AccountTypeFlag: subele.AccountTypeFlag,
                    };
                  }
                });
                setCashAccountObj(fromAccount);
              }
              if (pay === 'BankPayment') {
                AllAccountsListing.map((subele) => {
                  if (ele.accountid == subele.value) {
                    fromAccount = {
                      label: subele.label,
                      value: subele.value,
                      AccountTypeFlag: subele.AccountTypeFlag,
                    };
                  }
                });
                setBankAccountObj(fromAccount);
              }
              amounts = ele.creditamount;
            }
          }
        });
      getTransactions(toAccount.value, entryData.vouchernumber);
      setState((prev) => ({
        ...prev,
        paidTo: toAccount,
        paidFrom: fromAccount,
        payableAmount: `${amounts}`,
      }));
      setInitialState((prev) => ({
        ...prev,
        paidTo: toAccount,
        paidFrom: fromAccount,
        payableAmount: `${amounts}`,
      }));
      setamountsFromTable((prev) => ({
        ...prev,
        paidTo: toAccount,
        paidFrom: fromAccount,
      }));
    }
    setamountsFromTable((prev) => ({
      ...prev,
      tdsAmount: tdsAmount,
      payableAmount: amounts,
    }));
    setBackdropOpen(false);
  }
  async function getTdsTransaction(data) {
    try {
      const res = await API.graphql(graphqlOperation(getTransactionTDSDetails, { transactionid: data }));
      if (res.data.getTransactionTDSDetails !== null) {
        setTdsID(res.data.getTransactionTDSDetails.transactionid);
      }
    } catch (error) {
      console.log('error', error);
    }
  }
  async function linkReceordPayment(Id, data) {
    try {
      let linkTransData = {};
      data.RelatedTransactionDetails.map((ele) => {
        linkTransData = {
          linkedamount: ele.CreditAmount != 0 ? ele.CreditAmount : ele.DebitAmount,
          transactiontypecd: data.TransactionTypeCD,
          objectattribute: data.VoucherNumber,
          isdirect: 0,
          objectid: Id,
          objecttype: 'PurchaseInvoice',
          transactionid: ele.TransactionID,
        };
      });
      const res = await API.graphql(
        graphqlOperation(createTransactionRelation, {
          createTransactionRelationInput: linkTransData,
        })
      );
    } catch (error) {
      console.log('error', error);
    }
  }

  async function getFromAccountBalanceAmount(data) {
    try {
      const accountBalance = await API.graphql(graphqlOperation(getAccountBalance, { accountid: data }));

      if (accountBalance.data.getAccountBalance !== null) {
        let balance = accountBalance.data?.getAccountBalance[0]?.actualbalance;
        setFromBalanceAmount(balance);
      }
    } catch (error) {
      console.log('error', error);
    }
  }

  async function getToAccountBalanceAmount(data) {
    try {
      const accountBalance = await API.graphql(graphqlOperation(getAccountBalance, { accountid: data }));
      if (accountBalance.data.getAccountBalance !== null) {
        let balance = accountBalance.data?.getAccountBalance[0]?.actualbalance;
        setToBalanceAmount(balance);
      }
    } catch (error) {
      console.log('error', error);
    }
  }
  async function getAccountName() {
    let accName = {
      label: '',
      value: '',
      AccountTypeFlag: '',
    };
    console.log({ AllAccountsListing, eR: location.state.name });
    AllAccountsListing.map((ele) => {
      if (location?.state?.name?.toUpperCase()?.trim() === ele?.label?.toUpperCase()?.trim()) {
        accName = {
          label: ele.label,
          value: ele.value,
          AccountTypeFlag: ele.AccountTypeFlag,
        };
      }
    });

    setState((prev) => ({
      ...prev,
      paidTo: accName,
    }));
  }

  const updateAttachmentName = (id, newName) => {
    setAttachments(
      attachments.map((attachment) => (attachment.attachmentid === id ? { ...attachment, documentname: newName } : attachment))
    );
  };
  async function addAttachmets(data) {
    const attachRes = await API.graphql(
      graphqlOperation(createTransactionAttachment, {
        createTransactionAttachmentInput: data,
      })
    );
    if (attachRes.data?.createTransactionAttachment !== null) {
      setAttachedArr((prev) => [...prev, true]);
    } else {
      setAttachedArr((prev) => [...prev, false]);
    }
  }

  const {
    data: AccountMasterList,
    isLoading: isAccountMasterLoading,
    isError: AccountMasterError,
    refetch: refetchAccountMaster,
  } = useListAccountMasterv2Query(undefined, {
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    if (!AccountMasterList) {
      refetchAccountMaster();
    }
  }, [AccountMasterList]);
  let AllAccountsListing = useMemo(() => {
    if (!AccountMasterList) return [];
    let allAccount = [];
    AccountMasterList.map((item) => {
      let groupName = item.accountgroupname?.replace(/([a-z])([A-Z])/g, '$1 $2')?.trim();
      let AccountGroupID = item.accountgroupid;
      if (item.is_active === 1 && item.accountsid !== 23 && item.accountsid !== 24) {
        allAccount.push({
          label: `${item.accountname} `,
          value: item.accountsid,
          groupName,
          AccountGroupID,
          TDSSection: item.tdssection,
          TDSPercentage: item.tdspercentage,
          AccountTypeFlag: item.accounttypeflag,
          path: item.path,
        });
      }
      if (params.partyID && (!state.tdsApplicable || !state.TDSPercentage)) {
        const tdsofparty = allAccount.find((elem) => elem.value == params.partyID);
        console.log('tdsofparty', tdsofparty);
        setState((prev) => ({
          ...prev,
          tdsApplicable: `${tdsofparty?.TDSSection}`,
          TDSPercentage: tdsofparty?.TDSPercentage,
        }));
      } else {
        console.log('tdsof');
      }
    });
    return allAccount;
  }, [AccountMasterList]);

  let BankAccountsListing = useMemo(() => {
    if (!AccountMasterList) return [];
    let bankAccAr = [];
    AccountMasterList.map((item) => {
      let groupName = item.accountgroupname?.replace(/([a-z])([A-Z])/g, '$1 $2')?.trim();
      let AccountGroupID = item.accountgroupid;
      if ((item.accountgroupid === 17 || item.accountgroupid === 29) && item.is_active === 1) {
        bankAccAr.push({
          label: `${item.accountname} `,
          value: item.accountsid,
          groupName,
          AccountGroupID,
          AccountTypeFlag: item.accounttypeflag,
        });
      }
    });
    return bankAccAr;
  }, [AccountMasterList]);
  let CashAccountsListing = useMemo(() => {
    if (!AccountMasterList) return [];
    let cashAccArr = [];
    AccountMasterList.map((item) => {
      let groupName = item.accountgroupname?.replace(/([a-z])([A-Z])/g, '$1 $2')?.trim();
      let AccountGroupID = item.accountgroupid;
      if (item.accountgroupid === 16 && item.is_active === 1) {
        cashAccArr.push({
          label: `${item.accountname}`,
          value: item.accountsid,
          groupName,
          AccountGroupID,
          AccountTypeFlag: item.accounttypeflag,
        });
      }
    });
    return cashAccArr;
  }, [AccountMasterList]);

  async function saveChanges(obj) {
    try {
      let paymnentTransArr = [];
      const {
        vouchernumber,
        date,
        method,
        paidFrom,
        paidTo,
        payableAmount,
        tds,
        tdsApplicable,
        tdsAmount,
        paidAmount,
        bankRefNo,
        remarks,
        attachment,
        Towards,
      } = state;

      const formData = {
        vouchernumber,
        date,
        method,
        paidFrom,
        paidTo,
        payableAmount,
        tdsApplicable,
        tdsAmount,
        paidAmount,
        bankRefNo,
        remarks,
        attachment,
        tds,
      };
      const comments = state.remarks;
      if (formValidation(formData)) {
        setBackdropOpen(true);

        const masterData = {
          pdflink: uri,
          bankreferencenumber: bankRefNo,
          comments: comments,
          entrydate: Math.floor(new Date(date).getTime() / 1000),
          transactiontypecd: method,
          vouchercode: generalSettingsFlag == -1 ? state.vouchernumber : '',
          serialnumber: state.seriesVouchers.value,
          cancelflag: 0,
          towards: Towards || '',
        };

        const transactionCreditData = {
          accountid: paidFrom.value,
          comments: comments,
          creditamount:
            tdsAmount === '' || tdsAmount === 0 ? Number(payableAmount) : Number((Number(payableAmount) - Number(tdsAmount)).toFixed(2)),
          debitamount: 0,
          // entryordernumber: 1,
          transactiontypecd: 'Credit',
          cancelflag: 0,
        };
        const transactionDebitData = {
          accountid: paidTo.value,
          comments: comments,
          creditamount: 0,
          debitamount: Number(Number(payableAmount).toFixed(2)),
          // entryordernumber: 2,
          transactiontypecd: 'Debit',
          cancelflag: 0,
        };

        paymnentTransArr.push(transactionCreditData, transactionDebitData);
        let tdsData = {};
        if (state.tdsAmount) {
          tdsData = {
            tdsamount: tdsAmount == '' ? 0 : Number(tdsAmount),
            transactionid: entryData.transactionid,
            tdsapplicablecd: tdsApplicable,
            tdspercentage: state.TDSPercentage,
            tdsmanual: state.TDSManual,
          };
          const tdsDetaials = {
            accountid: 21,
            comments: comments,
            creditamount: tdsAmount == '' ? 0 : Number(Number(tdsAmount).toFixed(2)),
            debitamount: 0,
            // entryordernumber: 3,
            transactiontypecd: 'Credit',
            cancelflag: 0,
          };
          if (tdsData?.tdsamount != 0) {
            paymnentTransArr.push(tdsDetaials);
          }
        }

        let attachment = attachments.map((item) => {
          console.log(item, '&&&item');
          const attachmentData = {
            attachmentid: 0,
            attachmentname: item.imagename,
            attachmenturl: `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${item.imagename}`,
            documentname: item.documentname,
          };
          return attachmentData;
          // addAttachmets(attachmentData);
        });

        let sumOfLinkedTransaction = 0;
        let linkTransData = [];
        let imagesArray;

        console.log({ vouchers });
        if (vouchers.length > 0) {
          vouchers?.map((ele) => {
            if (ele.LinkedAmount) {
              linkTransData.push({
                linkedamount: ele.LinkedAmount,
                transactiontypecd: method,
                objectattribute: ele?.ObjectAttribute,
                objectid: ele.ObjectID,
                isdirect: ele.IsDirect,
                objecttype: ele.ObjectType,
                accountid: paidTo.value,
                paymentvouchernumber: state.vouchernumber,
                expiredtimestamp: 0,
              });
              sumOfLinkedTransaction += Number(ele.LinkedAmount);
            }
          });
        }
        if (sumOfLinkedTransaction > payableAmount) {
          return showWarningSnackbar('Linked Amount is greater than Paid To Amount');
        }
        let result = await baseQuery({
          body: createTransactionWithSpecificTimev2,
          variables: {
            createTransactionWithSpecificTimeInput: {
              transactionmaster: [masterData],
              transactiondetails: paymnentTransArr,
              transactionattachment: attachment,
              transactiontdsdetails: tdsData?.tdsamount ? [tdsData] : [],
              transactionrelation: linkTransData,
              mode: 1,
              transactiontcsdetails: [],
            },
          },
        });

        console.log(result, '&&&result');

        if (obj.preview) {
          setPreviewPaymentModal(true);
        }
        if (result?.data.statuscode == 'Success') {
          createPdf({
            path: url,
            type: 'payment',
            transactionid: result.data.transactionid,
          });
          let responses = await Promise.all(
            attachments.map(async (element) => {
              console.log(element, '!!!!element');
              if (element.file) {
                try {
                  console.log(`Uploading file: ${element.imagename}`);
                  const uploadResponse = await uploadToServer(
                    element.file,
                    element.imagename.replace('${id}', result.data.transactionid),
                    element.type
                  );
                  return {
                    success: true,
                    file: element.imagename,
                    response: uploadResponse,
                    type: element.type,
                    document: element.documentname,
                    attachmentid: element.attachmentid,
                  };
                } catch (error) {
                  const extracted = element.documentname;
                  return {
                    success: false,
                    file: element.imagename,
                    curreptedDocument: extracted,
                    error,
                    type: element.type,
                  };
                }
              }
            })
          );

          const res = await API.graphql(
            graphqlOperation(getTransactionMasterV2, {
              transactionid: result.data.transactionid,
            })
          );

          imagesArray = responses.map((item) => item.curreptedDocument).filter(Boolean);

          let imageUploadResponse = responses.filter((item) => item.success);
          let nweAttachments;
          let imageUploadArray;

          if (imagesArray.length > 0) {
            nweAttachments = res.data?.getTransactionMaster[0]?.relatedtransactionattachment;
            imageUploadArray = nweAttachments.filter((attachment) => imagesArray?.some((upload) => upload === attachment.documentname));

            const newImagesData = imageUploadArray.map((item) => ({
              attachmentid: item.attachmentid,
              transactionid: item.transactionid,
              expiredtimestamp: Math.floor(Date.now() / 10000),
              attachmentname: item.attachmentname,
              attachmenturl: item.attachmenturl,
              documentname: item.documentname,
              type: '.png',
            }));

            const updatedResponse = await API.graphql(
              graphqlOperation(createTransactionAttachment, {
                createTransactionAttachmentInput: newImagesData,
              })
            );
          }

          let response = await Promise.all(responses);
          handleNavigationBlocker(false);
          showSuccessSnackbar('Payment Entry created successfully');
          dispatch(VoucherSettingsApi.util.invalidateTags([{ type: 'listVoucherSettings', id: 'Payment' }]));
          dispatch(VoucherSettingsApi.util.invalidateTags(['listUsedVoucherSettings']));
          dispatch(dashboardApi.util.invalidateTags(['dashboard']));
          dispatch(paymentApi.util.invalidateTags([{ type: 'lastUsedAccount', id: 'payment' }]));
        } else {
          return showWarningSnackbar('Something went wrong !');
        }
        setBackdropOpen(false);
        if (obj.print) {
          handlePrint(true);
          navigate('/paymententries');
        } else if (obj.new === true) {
          getToAccountBalanceAmount(`${state.paidTo.value}`);
          // getTransactions(state.paidTo.value, null, params?.invoiceNumber);
          setState((prev) => ({
            ...prev,
            ...initialState,
            paidFrom: prev.paidFrom,
            method: prev.method,
          }));
          setvouchers([]);
          setAttachments([]);
          if (params.partyID) {
            getTransactions(params.partyID);
          }
        } else if (obj.new == false) {
          if (imagesArray.length === 0) {
            onSaveComplete();
          } else {
            setSummaryData({
              open: true,
              description: `${imagesArray.length == 1 ? 'Image' : 'Images'} cannot be uploaded`,
              lists: [...imagesArray],
              title: `${imagesArray.length == 1 ? 'Image' : 'Some images'} cannot be uploaded !`,
            });
          }
        } else {
          setState(initialState);
          // window.location.reload();
        }
        invalidateAllVoucherSerialNumbers();
      } else {
        window.scrollTo(0, 0);
      }
    } catch (error) {
      console.log(error, '****error');
      showErrorSnackbar(error.message);
      setBackdropOpen(false);
    } finally {
      setBackdropOpen(false);
    }
  }

  async function saveEditChanges({ toCancel = 0, CancelRemark = '' } = {}) {
    try {
      let paymentTransArr = [];
      const {
        vouchernumber,
        date,
        method,
        paidFrom,
        paidTo,
        payableAmount,
        tds,
        tdsApplicable,
        tdsAmount,
        paidAmount,
        bankRefNo,
        remarks,
        attachment,
        Towards,
      } = state;

      const formData = {
        vouchernumber,
        date,
        method,
        paidFrom,
        paidTo,
        payableAmount,
        tdsApplicable,
        tdsAmount,
        paidAmount,
        bankRefNo,
        remarks,
        attachment,
        tds,
      };
      if (formValidation(formData)) {
        setBackdropOpen(true);
        const entrydate = Math.floor(new Date(date).getTime() / 1000);
        const comments = state.remarks;
        const masterData = {
          pdflink: uri,
          transactionid: entryData?.transactionid,
          bankreferencenumber: bankRefNo,
          entrydate: entrydate,
          serialnumber: state.seriesVouchers.value,
          comments: comments,
          vouchercode: state.vouchernumber,
          transactiontypecd: state.method,
          cancelflag: toCancel ?? 0,
          cancelremark: CancelRemark ?? '',
          towards: Towards || '',
        };

        const transactionCreditData = {
          accountid: paidFrom.value,
          comments: comments,
          creditamount: tdsAmount === '' || tdsAmount === 0 ? Number(payableAmount) : Number(payableAmount) - Number(tdsAmount),
          debitamount: 0,
          // entryordernumber: 1,
          transactionid: entryData.transactionid,
          enteredtimestamp: entrydate,
          transactiontypecd: 'Credit',
          cancelflag: toCancel ?? 0,
        };

        const transactionDebitData = {
          accountid: paidTo.value,
          comments: comments,
          creditamount: 0,
          debitamount: payableAmount,
          // entryordernumber: 2,
          transactionid: entryData.transactionid,
          enteredtimestamp: entrydate,
          transactiontypecd: 'Debit',
          cancelflag: toCancel ?? 0,
        };
        paymentTransArr.push(transactionCreditData, transactionDebitData);
        if (state.tdsAmount) {
          const tdsDetaials = {
            accountid: 21,
            comments: comments,
            creditamount: tdsAmount == '' ? 0 : Number(tdsAmount),
            debitamount: 0,
            // entryordernumber: 3,
            transactionid: entryData.transactionid,
            enteredtimestamp: entrydate,
            transactiontypecd: 'Credit',
            cancelflag: toCancel ?? 0,
          };
          paymentTransArr.push(tdsDetaials);
        }

        let tdsData = {};
        if (state.tdsAmount) {
          if (tdsID !== '') {
            tdsData = {
              transactionid: entryData.transactionid,
              tdsamount: state.tdsAmount === '' || tdsAmount === '' ? 0 : Number(tdsAmount),
              tdsapplicablecd: state.tdsAmount ? tdsApplicable : '',
              tdspercentage: state.TDSPercentage,
              tdsmanual: state.TDSManual,
            };
          } else {
            tdsData = {
              tdsamount: tdsAmount === '' ? 0 : Number(tdsAmount),
              tdsapplicablecd: tdsApplicable,
              transactionid: entryData.transactionid,
              tdspercentage: state.TDSPercentage,
              tdsmanual: state.TDSManual,
            };
          }
        }

        let attachment = attachments.map((item) => {
          const attachmentData = {
            attachmentid: typeof item.attachmentid === 'string' ? 0 : item.attachmentid,
            attachmentname: item.imagename,
            documentname: item.documentname,
            attachmenturl: `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${item.imagename}`,
            transactionid: entryData?.transactionid,
            type: item.type,
            file: item.file ?? null,
          };
          return attachmentData;
        });

        let linkTransData = [];
        let sumOfLinkedTransaction = 0;
        if (vouchers.length > 0) {
          vouchers?.map((ele) => {
            if (ele.LinkedAmount || ele.PreviousLinkedAmount) {
              linkTransData.push({
                linkedamount: ele.LinkedAmount,
                transactiontypecd: method,
                objectattribute: ele.ObjectAttribute,
                objectid: ele.ObjectID,
                isdirect: ele.IsDirect,
                objecttype: ele.ObjectType,
                accountid: paidTo.value,
                paymentvouchernumber: state.vouchernumber,
                transactionid: entryData?.transactionid,
                expiredtimestamp: ele.LinkedAmount > 0 ? 0 : dayjs().unix(),
              });
            }
            sumOfLinkedTransaction += Number(ele.LinkedAmount);
          });
        }

        if (sumOfLinkedTransaction > payableAmount) {
          return showWarningSnackbar('Linked Amount is greater than Paid To Amount');
        }
        localStorage.removeItem('PaymentTransactionID');
        localStorage.removeItem('PaymentViewMode');
        if (linkTransData.length == 0 && LinkedVouchers.length > 0) {
          linkTransData = LinkedVouchers.map((ele) => {
            return {
              linkedamount: ele.LinkedAmount,
              transactiontypecd: ele.TransactionTypeCD,
              objectattribute: ele?.ObjectAttribute,
              objectid: ele.ObjectID,
              isdirect: ele.IsDirect,
              objecttype: ele.ObjectType,
              accountid: amountsFromTable?.paidTo?.value,
              paymentvouchernumber: state.vouchernumber,
              transactionid: entryData?.transactionid,
              expiredtimestamp: dayjs().unix(),
            };
          });
        }
        let result = await baseQuery({
          body: createTransactionWithSpecificTimev2,
          variables: {
            createTransactionWithSpecificTimeInput: {
              transactionmaster: [masterData],
              transactiondetails: paymentTransArr,
              transactionattachment: attachment,
              transactiontdsdetails: tdsData?.tdsamount ? [tdsData] : [],
              transactionrelation: linkTransData,
              mode: 0,
              transactiontcsdetails: [],
            },
          },
        });
        if (result.data?.statuscode === 'Success') {
          createPdf({
            path: url,
            type: 'payment',
            transactionid: result.data.transactionid,
          });
          let failedUploads = [];
          let responses = await Promise.all(
            attachment.map(async (element) => {
              if (element.file) {
                try {
                  console.log(`Uploading file: ${element.attachmentname}`);
                  const uploadResponse = await uploadToServer(
                    element.file,
                    element.attachmentname.replace('${id}', result.data.transactionid),
                    element.type
                  );
                  return {
                    success: true,
                    file: element.imagename,
                    response: uploadResponse,
                    type: element.type,
                    document: element.documentname,
                    attachmentid: element.attachmentid,
                  };
                } catch (error) {
                  console.error(`Error uploading: ${element.attachmentname}`, error);
                  const extracted = element.documentname;
                  failedUploads.push(extracted);
                  return {
                    success: false,
                    file: element.imagename,
                    curreptedDocument: extracted,
                    error,
                    type: element.type,
                  };
                }
              }
            })
          );

          if (failedUploads.length > 0) {
            const res = await API.graphql(
              graphqlOperation(getTransactionMasterV2, {
                transactionid: result.data.transactionid,
              })
            );

            const suceesUploadedDocumemnts = responses.filter((item) => item.success);

            let nweAttachments;
            let imageUploadArray;
            nweAttachments = res.data?.getTransactionMaster[0]?.relatedtransactionattachment;
            imageUploadArray = nweAttachments.filter((attachment) => failedUploads?.some((upload) => upload === attachment.documentname));

            const updatedImageArray = imageUploadArray.map((item) => ({
              attachmentid: item.attachmentid,
              transactionid: item.transactionid,
              expiredtimestamp: Math.floor(Date.now() / 10000),
              attachmentname: item.attachmentname,
              attachmenturl: item.attachmenturl,
              documentname: item.documentname,
              type: item.type,
            }));

            const updatedresponse = await API.graphql(
              graphqlOperation(createTransactionAttachment, {
                createTransactionAttachmentInput: updatedImageArray,
              })
            );
            setSummaryData({
              open: true,
              description: `${failedUploads.length == 1 ? 'Image' : 'Images'} cannot be uploaded`,
              lists: [...failedUploads],
              title: `${failedUploads.length == 1 ? 'Image' : 'Some images'} cannot be uploaded !`,
            });
          } else {
            dispatch(setNavigationBlocked(false));
            navigate('/paymententries', { force: true });
          }

          let response = await Promise.all(responses);

          dispatch(setNavigationBlocked(false));

          // navigate("/paymententries");
          toCancel
            ? showSuccessSnackbar('Payment Entry Cancelled successfully')
            : showSuccessSnackbar('Payment Entry Updated successfully');
          // showSuccessSnackbar("Payment Entry Updated successfully");

          dispatch(dashboardApi.util.invalidateTags(['dashboard']));
          dispatch(paymentApi.util.invalidateTags([{ type: 'lastUsedAccount', id: 'payment' }]));
        } else {
          showErrorSnackbar('Something went wrong !');
        }
        setBackdropOpen(false);
      } else {
        window.scrollTo(0, 0);
      }
    } catch (error) {
      console.log('error', error);
      showErrorSnackbar(error.message);
      setBackdropOpen(false);
    } finally {
      setBackdropOpen(false);
    }
  }
  function formValidation(data) {
    let isvalid = true;
    let fieldErrors = [];
    let obj = { ...state };
    Object.keys(data).map((itemKey) => {
      if (itemKey === 'date') {
        const startDate = moment(openingDate);
        const endDate = moment.unix(userPreferece.financialYear.enddate);
        const errorStartDate = startDate.format(DEFAULT_DATE_FORMAT);
        const errorEndDate = endDate.format(DEFAULT_DATE_FORMAT);
        if (!moment(data[itemKey]).isBetween(startDate, endDate, undefined, '[]')) {
          obj.errorStatus.date = true;
          obj.errorFields.date = `Date must be within ${errorStartDate} and ${errorEndDate}.`;
          document.getElementById('paymentDate').focus();
          isvalid = false;
        }
      }
      if (itemKey === 'paidFrom') {
        if (data[itemKey]?.value?.length <= 0 && paymentFlag == true) {
          isvalid = false;
          obj.errorFields.paidFrom = 'Paid From Field is required';
          obj.errorStatus.paidFrom = true;
          fieldErrors.push(obj.errorFields.paidFrom);
          if (obj.errorStatus.paidTo !== true) {
            document.getElementById('paidFrom').focus();
          }
        } else if (obj.paidFrom.value == obj.paidTo.value) {
          isvalid = false;
          obj.errorFields.paidFrom = 'Paid From Field and Paid To should be different';
          obj.errorStatus.paidFrom = true;
          if (obj.errorStatus.paidTo !== true) {
            document.getElementById('paidFrom').focus();
          }
        } else {
          // isvalid=true;
          obj.errorFields.paidFrom = '';
          obj.errorStatus.paidFrom = false;
        }
      }
      if (itemKey === 'paidTo') {
        if (data[itemKey].value.length <= 0) {
          isvalid = false;
          obj.errorFields.paidTo = 'Paid To Field is required';
          fieldErrors.push(obj.errorFields.paidTo);
          document.getElementById('paidTo').focus();
          obj.errorStatus.paidTo = true;
        } else if (obj.paidFrom.value == obj.paidTo.value) {
          isvalid = false;
          obj.errorFields.paidTo = 'Paid From Field and Paid To should be different';
          document.getElementById('paidTo').focus();
          obj.errorStatus.paidTo = true;
        } else {
          // isvalid=true;
          obj.errorFields.paidTo = '';
          obj.errorStatus.paidTo = false;
        }
      }
      if (itemKey === 'payableAmount') {
        if (data[itemKey].trim().length <= 0) {
          isvalid = false;
          obj.errorFields.payableAmount = 'Amount Payable Field is required';
          fieldErrors.push(obj.errorFields.payableAmount);
          obj.errorStatus.payableAmount = true;
          if (obj.errorStatus.paidTo !== true && obj.errorStatus.receivedTo !== true) {
            document.getElementById('payableAmount').focus();
          }
        } else if (!new RegExp(/^[+-]?(?=.+)(?:[1-9]\d*|0)?(?:\.\d+)?$/).test(obj.payableAmount)) {
          isvalid = false;
          obj.errorFields.payableAmount = 'Invalid Amount';
          obj.errorStatus.payableAmount = true;
        } else if (parseFloat(data[itemKey]) < parseFloat(state.tdsAmount)) {
          if (obj.errorStatus.paidTo !== true && obj.errorStatus.receivedTo !== true) {
            document.getElementById('payableAmount').focus();
          }
          isvalid = false;
          obj.errorFields.payableAmount = 'Amount should be greater than TDS';
          obj.errorStatus.payableAmount = true;
        } else {
          obj.errorFields.payableAmount = '';
          obj.errorStatus.payableAmount = false;
        }
      }

      if (itemKey === 'paidAmount') {
        if (obj.paidAmount !== '' && !new RegExp(/^[+-]?(?=.+)(?:[1-9]\d*|0)?(?:\.\d+)?$/).test(obj.paidAmount)) {
          isvalid = false;
          obj.errorFields.paidAmount = 'Invalid Amount';
          obj.errorStatus.paidAmount = true;
        } else {
          // isvalid=true;
          obj.errorFields.paidAmount = '';
          obj.errorStatus.paidAmount = false;
        }
      }
      // if (state.method == "BankPayment") {
      //   if (itemKey === "bankRefNo") {
      //     if (
      //       obj.bankRefNo !== "" &&
      //       !/^[A-Z0-9\-\/_.]{9,18}$/.test(obj.bankRefNo)
      //     ) {
      //       isvalid = false;
      //       obj.errorFields.bankRefNo = "Invalid Bank Reference Number";
      //       obj.errorStatus.bankRefNo = true;
      //     } else {
      //       // isvalid=true;
      //       obj.errorFields.bankRefNo = "";
      //       obj.errorStatus.bankRefNo = false;
      //     }
      //   }
      // }
      if (itemKey === 'method') {
        if (data[itemKey].trim().length <= 0) {
          isvalid = false;
          obj.errorFields.method = 'Please Select a Payment Method';
          obj.errorStatus.method = true;
        } else {
          // isvalid=true;
          obj.errorFields.method = '';
          obj.errorStatus.method = false;
        }
      }
      if (itemKey === 'vouchernumber') {
        const { valid, message } = CheckVoucherValid(data[itemKey], 'Voucher Number');
        if (data[itemKey]?.trim().length <= 0) {
          isvalid = false;
          obj.errorFields.vouchernumber = 'Voucher Number is Required';
          fieldErrors.push(obj.errorFields.vouchernumber);
          obj.errorStatus.vouchernumber = true;
        } else if (!valid) {
          isvalid = false;
          obj.errorFields.vouchernumber = message;
          obj.errorStatus.vouchernumber = true;
          fieldErrors.push(message);
        } else {
          let valid = true;
          paymentVoucherNos.map((ele) => {
            if (ele.VoucherNumber !== vouchNo) {
              if (ele.VoucherNumber === state.vouchernumber) {
                valid = false;
              }
            }
          });

          if (valid == false) {
            isvalid = false;
            obj.errorFields.vouchernumber = 'Voucher Number already exists';
            obj.errorStatus.vouchernumber = true;
          } else {
            obj.errorFields.vouchernumber = '';
            obj.errorStatus.vouchernumber = false;
          }
        }
      }
    });
    setState(obj);
    if (fieldErrors.length > 0) {
      showWarningSnackbar(
        fieldErrors.map((msg) => msg.replace('is required', '').trim()).join(', ') +
          `${fieldErrors.length > 1 ? ' are required' : ' is required'}`
      );
    }
    return isvalid;
  }

  // async function listUserPreferenceData() {
  //   try {
  //     getFY(userPreferece?.financialYear?.FinancialYearID);
  //   } catch (error) {
  //     console.log("error", error);
  //   }
  // }
  // async function getFY(data) {
  //   try {
  //     let startDate = new Date(userPreferece.financialYear.StartDate * 1000)
  //       .toString()
  //       ?.split(" ");
  //     let endDate = new Date(Number(userPreferece.financialYear.EndDate) * 1000)
  //       .toString()
  //       ?.split(" ");

  //     let FyearStart = startDate[1] + " " + startDate[2] + " " + startDate[3];
  //     let FyearEnd = endDate[1] + " " + endDate[2] + " " + endDate[3];
  //     const formatDateString = (dateStr) =>
  //       moment(dateStr, "MMM DD YYYY").format("YYYY-MM-DD");

  //     const formattedStartDate = formatDateString(FyearStart);
  //     const formattedEndDate = formatDateString(FyearEnd);
  //     setCompanyFinYrStartDate(formattedStartDate);
  //     setCompanyFinYrEndDate(formattedEndDate);
  //   } catch (error) {
  //     console.log("Error", error);
  //   }
  // }
  useEffect(() => {
    getTdsDetails();
    listVoucherNos();
    // listUserPreferenceData();
  }, []);

  useEffect(() => {
    let partyID = '';
    partylist.map((ele) => {
      if (ele.Name == state.paidTo.label) {
        partyID = ele.value;
      }
    });
    setSupplierID(partyID);
  }, [state.paidTo]);

  useEffect(() => {
    if (state.paidFrom.value) {
      getFromAccountBalanceAmount(`${state.paidFrom.value}`);
    }
    if (state.paidTo.value) {
      getToAccountBalanceAmount(`${state.paidTo.value}`);
    }
  }, [state.paidFrom, state.paidTo]);

  useEffect(() => {
    if (params?.id) {
      getEntryData(params?.id);
      setViewMode(params?.view);
    }
  }, []);

  useEffect(() => {
    if (entryData && Object.keys(entryData)?.length > 0 && AllAccountsListing?.length) {
      getPaymentDetails();
    }
  }, [entryData]);

  useEffect(() => {
    getItemSettings();
  }, [generalSettings]);

  useEffect(() => {
    if (location?.state?.name) {
      getAccountName();
    }
  }, [AllAccountsListing, location?.state?.name]);

  let userData = useSelector((state) => state.userDetailsReducer?.userDetails);

  function handlePrint(status) {
    //     const html = `
    //     <html>
    //         <head>
    //             <meta name="viewport" />
    //             <style rel="stylesheet">
    //             @media print {
    //   @page {
    //     margin: 0;
    //   }

    //   .header,
    //   .footer {
    //     display: none;
    //   }
    // }
    //             .moneyAlign{
    //                 text-align:right
    //                }
    //                .firsttable thead td{
    //                 font-size: 12px;
    //               }
    //                .firsttable tbody td {
    //                font-size: 10px;
    //                border:none;
    //                padding:1px 5px;
    //              }
    //                .thirdDiv thead td {
    //                 font-size: 9px;
    //                 padding:0px;
    //               }

    //               .thirdDiv tbody td {
    //                 font-size: 10px;
    //                 border:none;
    //                 padding:1px;

    //               }

    //               .thirdDiv tfoot td {
    //                 font-size: 12px;
    //                 text-align:right;
    //               }
    //             .firstDiv{
    //               font-size:12px;
    //             }
    //             table, th, td {

    //               border-collapse: collapse;
    //             }
    //             .fourthTable thead td {
    //               font-size: 12px;
    //             }
    //             .fourthTable tbody td {
    //               font-size: 10px;
    //               border:none;
    //             }
    //             .hsnTable tbody td {
    //               font-size: 10px;
    //               border:none;
    //             }
    //                </style>
    //         </head>
    //         <body>

    //   <div style="min-height: 285px; margin-left: auto; margin-right: auto; width:95%;
    //   margin-left: auto; margin-right: auto; padding-top: 5px">
    //   <div style="width: 100%; float: center;">
    //   <div style="display: flex; flex-direction:column; padding:10px 0px">
    //   <div style="display:flex; flex-direction:row-reverse; justify-content:space-between;">
    //   <div >
    //   ${
    //     companyDetails?.relatedcompanydetailsnew?.[0].companylogourl == `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/` ||
    //     companyDetails?.relatedcompanydetailsnew?.[0].companylogourl == ''
    //       ? `

    //   `
    //       : `
    //   <img src="${companyDetails?.relatedcompanydetailsnew?.[0].companylogourl}"
    //   alt="CompanyLogo" width="80px" height="80px">
    //   `
    //   }
    //     </div >
    //     <div style="max-width:40%;word-break:break-word;" >
    //   <span style="font-size: 15px; padding-bottom: 5px;
    //    font-weight:bold;">
    //    ${companyDetails?.companyname}
    //   </span><br/>

    //   <span style="font-size: 12px;max-width:50% ">
    //         ${
    //           companyDetails?.line1?.replace(/[**  ,]+/g, '') ? companyDetails?.line1?.replace(/[**  ,]+/g, ' ') + ', ' : ''
    //         }</span>   <span style="font-size: 12px;">${companyDetails?.city ? companyDetails?.city?.replace('District', '') + ', ' : ''}${
    //       companyDetails?.district?.replace('District', '') ? companyDetails?.district?.replace('District', '') + ', ' : ''
    //     }${companyDetails?.statename ? companyDetails?.statename.replace('District', '') + ', ' : ''}${companyDetails?.countrycode?.replace(
    //       'State',
    //       ''
    //     )}</span>
    //         <span style="font-size: 12px;
    //        ">${companyDetails?.pincode && ', ' + companyDetails?.pincode?.split('**').join('\n')}
    //   </span>
    //   <br/>
    //   ${
    //     companyDetails?.relatedcompanyentity?.[0].gstin && companyDetails?.relatedcompanydetailsnew?.[0].registrationtype !== 3
    //       ? `
    //   <span style="font-size: 12px;
    //   ">
    //   <strong>GSTIN : </strong> ${companyDetails?.relatedcompanyentity?.[0].gstin}
    //   </span>`
    //       : ''
    //   }
    //   </div>
    //   </div>

    //   </div>
    //   </div>

    //            <div style="  display:flex; flex-direction:column; justify-content: space-between;align-items:end">
    //                 <span style="">Payment No: ${state?.vouchernumber !== '' ? state.vouchernumber : ''}</span>
    //                 <span style="">Payment Date: ${state?.date ? moment(state?.date).format(DEFAULT_DATE_FORMAT) : ''}</span>
    //             </div>
    //        <div>
    //        <br>
    //       Paid To M/s
    //        ${state.paidTo.label} Rs ${MoneyFormatv3(Number(state.payableAmount).toFixed(2))} ( ${getWords(
    //       Number(state.payableAmount).toFixed(2)
    //     )} only ) <span style="white-space:nowrap;">By ${
    //       state.method == 'CashPayment'
    //         ? `Cash ${state.Towards ? '' : '.'}`
    //         : `Bank ${state.bankRefNo?.length > 0 ? `, Ref No: ${state.bankRefNo}` : ''} `
    //     } ${state.Towards ? `, towards : ${state.Towards}.` : ''}
    //     </span><br> ${Number(state?.tdsAmount) ? `TDS Rs ${MoneyFormatv3(Number(state?.tdsAmount))} deducted.` : ''}
    //        </div>
    // <br>
    // <div style="display:flex;flex-direction:row;justify-content: space-between; ">
    // <div>
    // Name : ${userData.name ?? ''}<br>${userData.designation?.length ? `Designation : ${userData.designation}` : ``}
    // </div >
    // <div >
    // Signature
    // </div>
    // </div>
    // </div >
    // </body >
    // </html > `;

    const dataForPrint = {
      companyDetails,
      state,
      userData,
      vouchers: vouchers.filter((data) => data.LinkedAmount > 0),
      type: 'Payment',
    };

    let html1 = ReceiptPrint(dataForPrint);

    if (status === true) {
      return html1;
    } else {
      printJS({
        printable: html1,
        type: 'raw-html',
        documentTitle: 'Payment',
      });
    }
  }

  const journalHTML = `
  <html>
  <head>
    <meta name="viewport" />
  </head>
  <body>
    <table cellpadding="2" cellspacing="0" width="100%" 
      style="margin-top: 10px; border-collapse: collapse; border: solid 1px ${theme.palette.background.tablebg}">
      <thead>
        <tr style="font-size:15px;background-color: ${theme.palette.background.tablebg};">
          <td width="60%" style=" padding: 5px;font-size : 13px; ">Particulars</td>
          <td width="20%" align="center" style=" padding: 5px; font-size : 13px;text-align: right">Debit(₹)</td>
          <td width="20%" align="center" style=" padding: 5px; font-size : 13px;text-align: right">Credit(₹)</td>
        </tr>
      </thead>
      <tbody>
      ${
        state.paidTo.label !== ''
          ? `<tr style="color:#396afc; font-size:13px; border: solid 1px ${theme.palette.background.tablebg}">
           <td width="60%" style="border: solid 1px ${theme.palette.background.tablebg}; padding: 5px; font-size:13px">${
              state.paidTo.label === undefined ? state.paidTo : state.paidTo.label
            }</td>
           <td width="20%" align="center" style="border: solid 1px ${
             theme.palette.background.tablebg
           }; padding:5px; font-size:13px; text-align:right">
              ${MoneyFormatv3(Number(state.payableAmount).toFixed(2))}
           </td>
           <td width="20%" align="center" style="border: solid 1px ${theme.palette.background.tablebg}; padding:5px; font-size:13px"></td>
         </tr>`
          : ``
      }
      
      ${
        state.paidFrom.label !== ''
          ? `<tr style="color:#20e0cf;font-size:13px; border: solid 1px ${theme.palette.background.tablebg}">
           <td width="60%" style="border: solid 1px ${
             theme.palette.background.tablebg
           }; padding: 5px; padding-left: 25px;font-size : 13px">To  ${state.paidFrom.label}</td>
           <td width="20%" align="center" style="border: solid 1px ${theme.palette.background.tablebg}; padding: 5px;font-size : 13px"></td>
           <td width="20%" align="center" style="border: solid 1px ${
             theme.palette.background.tablebg
           }; padding: 5px;font-size : 13px; text-align: right">
              ${
                state.tdsAmount
                  ? MoneyFormatv3((Number(state.payableAmount).toFixed(2) - Number(state.tdsAmount).toFixed(2)).toFixed(2))
                  : MoneyFormatv3(Number(state.payableAmount).toFixed(2))
              }
           </td>
         </tr>`
          : ``
      }
      
      ${
        state.tdsAmount > 0
          ? `<tr style="color:#20e0cf; border: border: solid 1px ${theme.palette.background.tablebg};">
            <td width="60%" style="border: solid 1px ${
              theme.palette.background.tablebg
            }; padding: 5px; padding-left: 25px;font-size : 13px">To TDS Payable</td>
            <td width="20%" align="center" style="border: solid 1px ${
              theme.palette.background.tablebg
            }; padding: 5px;font-size : 13px"></td>
            <td width="20%" align="center" style="border: solid 1px ${
              theme.palette.background.tablebg
            }; padding: 5px;font-size : 13px; text-align: right">
              ${MoneyFormatv3(Number(state.tdsAmount).toFixed(2))}
            </td>
          </tr>`
          : ``
      }
  
      </tbody>
    </table>
  </body>
  </html>
  `;

  function deepEqual(obj1, obj2, ignoredKeys = ['date', 'paidFrom']) {
    if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) {
      return obj1 == obj2;
    }

    let keys1 = Object.keys(obj1).filter((key) => !ignoredKeys.includes(key));
    let keys2 = Object.keys(obj2).filter((key) => !ignoredKeys.includes(key));

    if (keys1.length !== keys2.length) {
      console.log('Mismatched keys:', {
        obj1Keys: keys1,
        obj2Keys: keys2,
        missingInObj1: keys2.filter((k) => !keys1.includes(k)),
        missingInObj2: keys1.filter((k) => !keys2.includes(k)),
      });
      return false;
    }

    for (let key of keys1) {
      if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
        console.log('Mismatch at key:', key, {
          obj1Value: obj1[key],
          obj2Value: obj2[key],
        });
        return false;
      }
    }

    return true;
  }

  const [reloadFn, setReloadFn] = useState(false);
  let aaaa = false; // not inuse but it's mandatory in this function
  useEffect(() => {
    window.addEventListener('click', (e) => {
      if (e.target.innerText === 'SAVE & NEW') {
        setReloadFn(true);
        aaaa = true;
      }
    });
    if (state?.vouchernumber) {
      dispatch(updateTitle(state.vouchernumber));
    }
  }, [state]);

  const [reNavigate, setReNavigate] = useState('');

  let clickFn = (e) => {
    if (!deepEqual(state, initialState) || attachments.length !== initialAttachments.length) {
      if (!modalOpen) {
        e.preventDefault();
        e.stopPropagation();
        setModalOpen(true);
      }
      return;
    }
    if (attachments.length === initialAttachments.length) {
      attachments.map((e, index) => {
        if (!deepEqual(attachments[index], initialAttachments[index])) {
          if (!modalOpen) {
            e.preventDefault();
            e.stopPropagation();
            setModalOpen(true);
          }
          return;
        }
      });
    }
  };
  const [aTags, setATags] = useState(document.getElementsByTagName('a').length);
  let selector = useSelector((state) => state.sidebarReducer?.SideBarOpts);
  let selectorDrawer = useSelector((state) => state.sidebarReducer);
  useEffect(() => {
    setATags(document.getElementsByTagName('a').length);
    if (selectorDrawer == true) {
      setTimeout(() => {
        setATags(document.getElementsByTagName('a').length);
      }, 100);
    }
  }, [selectorDrawer, selector]);

  const handleNavigationBlocker = (value) => {
    dispatch(setNavigationBlocked(value));
  };

  const [isDirty, setIsDirty] = useState(false);

  useEffect(() => {
    if (params.view) return;
    const isDataModified = !deepEqual(state, initialState);
    console.log({ state, initialState });
    const isAttachmentsModified = attachments.length !== initialAttachments.length;

    const shouldBeDirty = isDataModified || isAttachmentsModified;

    if (shouldBeDirty !== isDirty) {
      setIsDirty(shouldBeDirty);
    }
  }, [state, aTags, attachments, isDirty]);

  useEffect(() => {
    dispatch(setNavigationBlocked(isDirty));
  }, [isDirty, dispatch]);

  // useEffect(() => {
  //   if (
  //     !deepEqual(state, initialState) ||
  //     attachments.length !== initialAttachments.length
  //   ) {
  //     handleNavigationBlocker(true);
  //   }
  //   if (attachments.length === initialAttachments.length) {
  //     attachments.map((e, index) => {
  //       if (!deepEqual(attachments[index], initialAttachments[index])) {
  //         handleNavigationBlocker(true);
  //       }
  //     });
  //   }
  //   return () => {
  //     handleNavigationBlocker(false);
  //   };
  // }, [state, aTags, attachments]);

  const handleTdsKeydown = (e) => {
    if ((e.key === 'Tab' || e.key === 'Enter') && state.tdsApplicable && state.tdsAmount === '') {
      console.log('====> enterd inside');
      e.preventDefault();
      e.stopPropagation();
      setState((prev) => ({
        ...prev,
        tdsAmount: '',
        // TDSManual: 1,
        errorStatus: {
          ...prev.errorStatus,
          payabltdsAmounteAmount: true,
        },
        errorFields: {
          ...prev.errorFields,
          tdsAmount: 'TDS Amount is required',
        },
      }));
    }
    console.log(e.key, '===>key pressed is ');
  };

  let [modalOpen, setModalOpen] = useState(false);
  const modalClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setModalOpen(false);
    }
  };
  const filterOptions = createFilterOptions({
    matchFrom: 'any',
    stringify: (option) => option.option,
  });
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    boxShadow: 24,
    outline: 'none',
    minWidth: '400px',
  };
  const handleFileChange = (event) => {
    const files = event.target.files;
    const allowedTypes = [
      'application/msword',
      'application/pdf',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-powerpoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'image/jpeg',
      'image/jpg',
      'image/png',
    ];

    let allFilesValid = true;

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (!allowedTypes.includes(file.type)) {
        showWarningSnackbar('This format is not allowed');
        allFilesValid = false;
        break;
      }
    }

    if (allFilesValid) {
      setAttachments((currentAttachments) => {
        if (attachments.length + files.length > 6) {
          showWarningSnackbar('You cannot add more than 6 attachments');
          return currentAttachments;
        }

        const newAttachments = Array.from(files).map((file) => ({
          attachmentid: currentAttachments.attachmentid ? currentAttachments.attachmentid : Date.now() + file.name,
          imagename: currentAttachments.attachmentname
            ? currentAttachments.attachmentname
            : path + 'Payments/' + '${id}/LedgerX_' + Date.now() + file.name,
          documentname: file.name,
          type: currentAttachments.type ? currentAttachments.type : file.type,
          imageurl: currentAttachments.imageurl ? currentAttachments.imageurl : URL.createObjectURL(file),
          file,
        }));

        const filteredNewAttachments = newAttachments.filter(
          (newAttachment) => !currentAttachments.some((attachment) => attachment.documentname === newAttachment.documentname)
        );

        return [...currentAttachments, ...filteredNewAttachments];
      });
    } else {
      // Optionally clear the file input if invalid file detected
      event.target.value = ''; // This resets the file input
    }

    if (imageRef.current) {
      imageRef.current.value = '';
    }
  };

  const [focusRadioGrp, setFocusRadioGrp] = useState(false);

  const calculateBalance = (value, noSymbol) => {
    let post = '';
    if (value > 0) {
      post = '(Cr)';
    } else if (value < 0) {
      post = '(Dr)';
    }
    if (noSymbol) {
      return value;
    }
    value = Math.abs(value);
    return MoneyFormatv3(value) + ' ' + post;
  };

  const BalanceAmountCalculator = ({ balance = 0, balanceSign = 1, oldBalance = 0, newBalance, sign, oldAccountid, newAccountid }) => {
    console.log({
      balance,
      balanceSign,
      oldBalance,
      newBalance,
      sign,
      amountsFromTable,
    });
    let result = 0;
    let temp = oldAccountid == newAccountid ? newBalance - oldBalance : newBalance;
    if (sign === 'credit' && balanceSign === 1) {
      result = calculateBalance((balance + temp) * -1);
    } else if (sign === 'debit' && balanceSign === -1) {
      result = calculateBalance(balance + temp);
    } else {
      result = calculateBalance((balance - temp) * -balanceSign);
    }
    console.log(result);
    return result;
  };

  const [vouchers, setvouchers] = useState([]);
  const [LinkedVouchers, setLinkedVouchers] = useState([]);
  let getTransactions = async (value, voucherNumber, invoicenumber) => {
    try {
      let responses = await Promise.all([
        !params.view
          ? API.graphql(
              graphqlOperation(listPartyInvoicePurchases, {
                accountid: value,
              })
            )
          : '',
        voucherNumber
          ? API.graphql(
              graphqlOperation(getLinkedReceipts, {
                vouchernumber: voucherNumber,
              })
            )
          : '',
      ]);
      let response = responses[0];
      let linkedTransactionResponse = responses[1];
      let linkedTransactions = new Set(
        linkedTransactionResponse?.data?.getLinkedReceipts?.map((elem) => {
          let Total = elem.invoiceamount || elem.grandtotalamount;
          let InvoiceId = elem.purchaseid || elem.invoiceid || elem.objectid;
          let dueAmount = elem.balancedueamount || 0;
          let ObjectAttribute = elem.invoicenumber || elem.invoicenumber;

          return {
            PreviousLinkedAmount: elem.linkedamount,
            LinkedAmount: elem.linkedamount,
            TransactionTypeCD: elem.transactiontypecd,
            ObjectAttribute: ObjectAttribute,
            IsDirect: 0,
            ObjectID: InvoiceId,
            ObjectType: elem.objecttype,
            TransactionID: elem.transactionid,
            dueAmount,
            Total,
            invoicedate: elem.invoicedate,
          };
        })
      );

      let transactions = [];
      if (!params.view) {
        transactions =
          response.data.listPartyInvoicePurchases
            .filter(
              (elem) =>
                !Array.from(linkedTransactions).find((ele) => ele.ObjectAttribute == elem.invoicenumber) &&
                elem.invoicetypecd !== 'DebitNote' &&
                elem.invoicetypecd !== 'SalesInvoice'
            )
            .filter((elem) => (invoicenumber ? elem.vouchernumber == invoicenumber || elem.invoicenumber == invoicenumber : true))
            .map((elem) => {
              let Total = elem.invoiceamount || elem.granttotalamount;
              let InvoiceId = elem.purchaseid || elem.invoiceid || elem.objectid;
              let dueAmount = elem.purchasebalancedueamount || elem.invoicebalancedueamount;
              let ObjectAttribute = elem.vouchernumber || elem.invoicenumber;
              return {
                PreviousLinkedAmount: 0,
                LinkedAmount: 0,
                TransactionTypeCD: state.method,
                ObjectAttribute: ObjectAttribute,
                IsDirect: 0,
                ObjectID: InvoiceId,
                ObjectType: elem.invoicetypecd,
                TransactionID: '',
                dueAmount,
                Total,
                invoicedate: elem.invoicedate,
              };
            }) || [];
      }
      let mergedVouchers = [...transactions];
      if (linkedTransactionResponse) {
        mergedVouchers = [...Array.from(linkedTransactions), ...mergedVouchers];
        setLinkedVouchers(Array.from(linkedTransactions));
      }
      setvouchers(mergedVouchers);
    } catch (error) {
      console.log(error);
    }
  };

  // useEffect(() => {
  //   if (params?.partyID) {
  //     getTransactions(params?.partyID, null, params?.invoiceNumber);
  //   }
  //   return () => { };
  // }, []);

  const id = paidTo?.value || params?.partyID;
  useEffect(() => {
    if (id) {
      getTransactions(id, null, params?.invoiceNumber);
    }
    return () => {};
  }, [id]);

  let handleLinkedAmount = (value, index) => {
    let temp = JSON.parse(JSON.stringify(vouchers));
    let availableBalance = balanceInReceipt(index);
    let check = true;
    if (value > temp[index].Total) {
      return showWarningSnackbar('Amount is greater than invoice amount');
    }
    if (availableBalance < value && value >= temp[index].LinkedAmount) {
      temp[index].LinkedAmount = availableBalance;
      setvouchers(temp);
      showWarningSnackbar('no balance left !');
      return false;
    }
    if (typeof value == 'boolean') {
      if (value == true) {
        let balance =
          Number(temp[index].dueAmount) + (Number(temp[index].PreviousLinkedAmount || 0) + Number(temp[index].LinkedAmount || 0));
        if (temp[index].dueAmount > availableBalance) {
          value = availableBalance;
        } else {
          value = balance;
        }
      } else {
        value = 0;
      }
    }

    temp[index].LinkedAmount = value;
    setvouchers(temp);
    return check;
  };
  let balanceInReceipt = (index = undefined) => {
    let balance = state.payableAmount;
    let linkedTotal = vouchers.reduce((sum, item, indexx) => sum + Number(index != indexx ? item.LinkedAmount : 0), 0);
    return Number(balance) - Number(linkedTotal);
  };
  const Freeze = useSelector((state) => state.userPrefrenceandReducer?.financialYear?.freezestatus);
  // useSaveShortcut(
  //   params?.id && params?.view !== true
  //     ? () => {
  //       saveEditChanges();
  //     }
  //     : params?.view !== true
  //       ? () => saveChanges({ new: false })
  //       : undefined
  // );

  useSaveShortcutV1(
    params?.id && params?.view !== true
      ? () => {
          saveEditChanges();
        }
      : params?.view !== true
      ? () => saveChanges({ new: false })
      : undefined,
    accountIDTransaction,
    settingsModal,
    openBankModal,
    fromAccountModal ? true : false
  );

  const handleKeyDownn = (e) => {
    if ((e.key === 'Tab' || e.key === 'Enter') && state.payableAmount === '') {
      e.preventDefault();
      e.stopPropagation();
      setState((prev) => ({
        ...prev,
        errorStatus: {
          ...prev.errorStatus,
          payableAmount: true,
        },
        errorFields: {
          ...prev.errorFields,
          payableAmount: 'Amount Payable field is required',
        },
      }));
    }
  };

  const handleTdsPercent = (e) => {
    if ((e.key === 'Tab' || e.key === 'Enter') && state.TDSPercentage === '') {
      e.preventDefault();
      e.stopPropagation();
      setState((prev) => ({
        ...prev,
        errorStatus: {
          ...prev.errorStatus,
          TDSPercentage: true,
        },
        errorFields: {
          ...prev.errorFields,
          TDSPercentage: ' % required',
        },
      }));
    }
  };

  console.log({ serialNos, activeVouchers, state });

  return (
    <Box
      className="PageHeight"
      sx={{
        width: '100%',
        backgroundColor: '',
        // paddingTop: modalEvent == true ? "30px" : "60px",
        // paddingRight: modalEvent === true ? "50px" : "0px",
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <ConfirmExit open={modalOpen} setOpen={setModalOpen} reNavigate={reNavigate} />
      <Box
        sx={{
          display: {
            xs: 'none',
            sm: 'flex',
            md: 'flex',
            lg: 'flex',
            xl: 'flex',
          },
          justifyContent: 'space-between',
          // marginTop: "15px",
          marginBottom: '10px',
        }}
      >
        <Box></Box>
      </Box>
      {/* </Box> */}
      <Box
        sx={
          {
            // marginLeft: { xs: "0px", sm: "80px" },
            // marginRight: { xs: "0px", sm: "80px" },
          }
        }
      >
        {/* {(viewMode == true && entryData?.CancelFlag !== undefined) && (
          <Alert
            variant="standard"
            sx={{ boxShadow: "none", marginBottom: "20px" }}
            severity="info"
          >
            {entryData.CancelFlag === 0
              ? ` Fields are disabled. To make changes${" "}`
              : "Invoice cancelled. No further updates can be made."}
            {entryData.CancelFlag === 0 ? (
              <Link
                underline="hover"
                id="editN"
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  // localStorage.removeItem("PaymentViewMode")
                  // localStorage.removeItem("PaymentTransactionID")
                  if (Freeze == 1) {
                    return handleFreeze()
                  }
                  setViewMode(false);
                  navigate("/editpaymententries", {
                    state: { id: entryData.TransactionID },
                  });
                }}
              >
                Enable Edit&nbsp;
                <EditIcon sx={{ fontSize: "14px", color: "#6096d9" }} />
              </Link>
            ) : null}
          </Alert>
        )} */}

        {viewMode === true && entryData?.cancelflag ? (
          <>
            <Box
              sx={{
                position: 'sticky',
                top: '10px',
                borderRadius: '8px',
                marginBottom: '0px',
                padding: { xs: '10px 0px', sm: '10px 10px' },
                transition: 'all 1s ease-in-out',
              }}
            >
              <Alert
                variant="standard"
                sx={{
                  color: entryData.cancelflag === 0 ? '' : 'red',
                  boxShadow: 'none',
                  width: 450,
                }}
                severity="error"
              >
                {entryData.cancelflag === 1 ? 'Paymnet cancelled. No further updates can be made.' : null}
              </Alert>
            </Box>
            <Box sx={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: '10' }}>
              <CancelUI />
            </Box>
          </>
        ) : null}
        <Box
          className="darkDisabledInputs"
          sx={{
            opacity: viewMode === true && entryData?.cancelflag ? '0.5' : '1',
            cursor: viewMode === true && entryData?.cancelflag ? 'no-drop' : 'default',
          }}
        >
          <Box
            sx={{
              borderRadius: '8px',
              // backgroundColor: "background.paper",
              marginBottom: '20px',
              // boxShadow:
              //   "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
              padding: { xs: '30px 20px ', sm: '0px 0px' },
              borderRadius: '8px',
              ':hover': {
                boxShadow: 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px',
              },
              transition: 'all 1s ease-in-out',
            }}
          >
            <Grid container rowSpacing={1} columnSpacing={1}>
              {/* <Grid item xs={12} sx={{ paddingRight: "10px" }}>
            
              <HeadingWithRuler text={"General Details"} />
            </Grid> */}

              <Grid item container sx={{ marginTop: '0px' }} rowSpacing={{ xs: 2, md: 0 }} columnSpacing={1}>
                <Grid
                  item
                  xs={12}
                  md={3}
                  // sx={{ padding: "0px 10px",fontSize:"14px" }}
                  className="relative"
                >
                  <Box sx={{ flex: { xs: 1 } }}>
                    <Box
                      onFocus={() => {
                        setFocusRadioGrp(true);
                      }}
                      onBlur={() => {
                        setFocusRadioGrp(false);
                      }}
                      onKeyDown={(e) => {
                        if (e.key == 'Enter') {
                          if (state.method == 'CashPayment') {
                            setState((prev) => ({
                              ...prev,
                              method: 'BankPayment',
                              paidFrom:
                                bankAccountObj?.label !== ''
                                  ? {
                                      label: bankAccountObj?.label,
                                      value: bankAccountObj?.value,
                                    }
                                  : {
                                      label: BankAccountsListing[0]?.label,
                                      value: BankAccountsListing[0]?.value,
                                    },
                            }));
                          } else {
                            setState((prev) => ({
                              ...prev,
                              method: 'CashPayment',
                              paidFrom:
                                cashAccountObj?.label !== ''
                                  ? {
                                      label: cashAccountObj?.label,
                                      value: cashAccountObj?.value,
                                    }
                                  : {
                                      label: CashAccountsListing[0]?.label,
                                      value: CashAccountsListing[0]?.value,
                                    },
                            }));
                          }
                        }
                      }}
                      sx={{
                        position: 'relative',
                        border: 'solid 1px',
                        borderColor: state.errorStatus.method === true ? 'danger.main' : 'input.border',
                        borderRadius: '4px',
                        padding: '4px 14px',
                        boxSizing: 'border-box',
                        fontSize: '14px',
                        '.css-ahj2mt-MuiTypography-root': {
                          fontSize: '12px',
                          color: state.errorStatus.method === true ? 'danger.main' : 'input.font',
                        },
                        '.css-1n70hd2-MuiButtonBase-root-MuiRadio-root': {
                          padding: '0px',
                          margin: '0px 5px',
                        },
                        '.css-1rfdfc4-MuiButtonBase-root-MuiRadio-root': {
                          padding: '0px',
                          margin: '0px 5px',
                          color: 'input.border',
                        },
                        '.css-1rfdfc4-MuiButtonBase-root-MuiRadio-root.Mui-checked': {
                          color: 'mary.main',
                        },
                        // background: focusRadioGrp ? "#DDDEF6" : "",
                        boxShadow: focusRadioGrp ? '0px 6px 8px rgba(0, 0, 0, 0.5)' : '',
                        '&:focus-within': {
                          backgroundColor: '#ffb74d', // Background when focused
                        },
                      }}
                    >
                      <Typography
                        error={state.errorStatus.method === true ? true : false}
                        sx={{
                          fontSize: { xs: '0.75rem', sm: '0.60em' },
                          letterSpacing: '0.00938em',
                          position: 'absolute',
                          top: '-8px',
                          left: '9px',
                          background: theme?.palette?.TmId.id.toString().includes('9') ? '#373843' : '#fff',
                          padding: '0px 8px 0px 2px',
                          color: state.errorStatus.method == true ? 'danger.main' : 'input.font',
                        }}
                      >
                        Payment From
                      </Typography>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <RadioGroup
                          disabled={viewMode == true || currentPaymentFlag == true ? true : false}
                          sx={{
                            display: 'flex',
                            flexDirection: { xs: 'row', sm: 'row' },
                          }}
                          name="method"
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === '') {
                              setPaymentFlag(false);
                              setState((prev) => ({
                                ...prev,
                                method: value,

                                errorStatus: {
                                  ...prev.errorStatus,
                                  method: true,
                                },
                                errorFields: {
                                  ...prev.errorFields,
                                  method: 'Please Select Payment Type',
                                },
                              }));
                            } else {
                              setPaymentFlag(true);
                              if (CashAccountsListing.length > 0 && value === 'CashPayment') {
                                let acc =
                                  AllAccountsListing.find((elem) => elem.value == lastCashAccount) ||
                                  cashAccountObj ||
                                  CashAccountsListing[0];
                                setState((prev) => ({
                                  ...prev,
                                  method: value,
                                  bankRefNo: '',
                                  paidFrom: acc?.label
                                    ? {
                                        label: acc?.label,
                                        value: acc?.value,
                                      }
                                    : {
                                        label: '',
                                        value: '',
                                      },
                                  errorStatus: {
                                    ...prev.errorStatus,
                                    method: false,
                                    paidFrom: false,
                                  },
                                  errorFields: {
                                    ...prev.errorFields,
                                    method: '',
                                    paidFrom: '',
                                  },
                                }));
                              } else if (BankAccountsListing.length > 0 && value == 'BankPayment') {
                                let acc =
                                  AllAccountsListing.find((elem) => elem.value == LastBankAccount) ||
                                  BankAccountsListing.find((elem) => elem.value == 39) ||
                                  BankAccountsListing?.[0];
                                setState((prev) => ({
                                  ...prev,
                                  method: value,
                                  paidFrom: acc?.label
                                    ? {
                                        label: acc?.label,
                                        value: acc?.value,
                                      }
                                    : {
                                        label: '',
                                        value: '',
                                      },
                                  errorStatus: {
                                    ...prev.errorStatus,
                                    method: false,
                                    paidFrom: false,
                                  },
                                  errorFields: {
                                    ...prev.errorFields,
                                    method: '',
                                    paidFrom: '',
                                  },
                                }));
                              } else {
                                setState((prev) => ({
                                  ...prev,
                                  method: value,
                                  paidFrom: { label: '', value: '' },
                                  errorStatus: {
                                    ...prev.errorStatus,
                                    method: false,
                                    paidFrom: false,
                                  },
                                  errorFields: {
                                    ...prev.errorFields,
                                    method: '',
                                    paidFrom: '',
                                  },
                                }));
                              }
                            }
                          }}
                          value={state.method}
                        >
                          <FormControlLabel
                            disabled={viewMode == true || currentPaymentFlag == true ? true : false}
                            name="method"
                            value="CashPayment"
                            control={<Radio size="small" disableRipple />}
                            label="Cash"
                          />
                          <FormControlLabel
                            disabled={viewMode == true || currentPaymentFlag == true ? true : false}
                            name="method"
                            value="BankPayment"
                            control={<Radio size="small" />}
                            label="Bank"
                          />
                        </RadioGroup>
                      </Box>
                    </Box>
                    <Typography className="error" sx={{ minHeight: '12px' }}>
                      {state?.errorFields.method}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} md={3} sx={{ padding: '0px 0px', marginTop: '0px' }}>
                  <Box sx={{ flex: { xs: 1, sm: 0.5 } }}>
                    <TextField
                      error={state.errorStatus.date === true ? true : false}
                      id="paymentDate"
                      label="Payment Date"
                      variant="outlined"
                      size="small"
                      disabled={paymentFlag == false || viewMode == true || currentPaymentFlag == true ? true : false}
                      type="date"
                      value={state.date}
                      // onChange={(e) => {
                      //   const value = e.target.value;

                      //   const startDate = moment(
                      //     userPreferece.financialYear.startdate * 1000
                      //   ).format("YYYY-MM-DD");
                      //   const endDate = moment(
                      //     userPreferece.financialYear.enddate * 1000
                      //   ).format("YYYY-MM-DD");

                      //   if (value !== "") {
                      //     if (
                      //       moment(value).isBetween(
                      //         startDate,
                      //         endDate,
                      //         undefined,
                      //         "[]"
                      //       )
                      //     ) {
                      //       setState((prev) => ({
                      //         ...prev,
                      //         date: value,
                      //         errorStatus: {
                      //           ...prev.errorStatus,
                      //           date: false,
                      //         },
                      //         errorFields: {
                      //           ...prev.errorFields,
                      //           date: "",
                      //         },
                      //       }));
                      //     } else {
                      //       setState((prev) => ({
                      //         ...prev,
                      //         date: value,
                      //         errorStatus: {
                      //           ...prev.errorStatus,
                      //           date: true,
                      //         },
                      //         errorFields: {
                      //           ...prev.errorFields,
                      //           date: "Date must be within the financial year range",
                      //         },
                      //       }));
                      //     }
                      //   }
                      // }}

                      onChange={(e) => {
                        const value = e.target.value;
                        handlePaymentDateChanges(value);
                      }}
                      InputProps={{
                        inputProps: {
                          min:
                            // params?.id && !isNaN(params.id)
                            //   ? firstInvoiceDate ||
                            // moment(openingBalanceDate, 'YYYY-MM-DD').format('YYYY-MM-DD') !== 'Invalid date'
                            openingDate ?? moment(userPreferenceAndFY.financialYear.startdate * 1000).format('YYYY-MM-DD'),

                          // : lastInvoiceDate ||
                          // moment(
                          //   userPreferenceAndFY.financialYear.startdate * 1000
                          // ).format("YYYY-MM-DD"),
                          max:
                            // params?.id && !isNaN(params.id)
                            //   ? nextInvoiceDate ||
                            moment(userPreferenceAndFY.financialYear.enddate * 1000).format('YYYY-MM-DD'),
                          // : moment(
                          //   userPreferenceAndFY.financialYear.enddate * 1000
                          // ).format("YYYY-MM-DD"),
                        },
                      }}
                      fullWidth
                      sx={{
                        '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                          fontSize: '14px',
                        },
                        label: {
                          fontSize: '14px',
                        },
                        '.css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root': {
                          color: 'input.border',
                        },
                        '.css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
                          borderColor: 'input.border',
                        },
                        '.css-1cqhiog-MuiInputBase-root-MuiOutlinedInput-root': {
                          color: '#a0a1a1c7',
                        },
                        '.css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root': {
                          color: '#a0a1a1c7',
                        },
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    <FormHelperText
                      style={{
                        fontSize: '12px',
                      }}
                      error={state.errorStatus.date}
                    >
                      {state.errorFields.date}
                    </FormHelperText>
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={3}
                  // sx={{ padding: "0px 10px", }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {generalSettingsFlag !== -1 && (
                      <Box sx={{ flex: 1, mr: 1 }}>
                        <Autocomplete
                          openOnFocus
                          disablePortal
                          disabled={
                            // isVoucherEditable && 
                            !viewMode && params?.id
                              ? false
                              : paymentFlag == false || viewMode == true || currentPaymentFlag == true || params?.id
                              ? true
                              : false
                          }
                          id="sereisVouchers"
                          options={serialNos}
                          value={state.vouchernumber}
                          isOptionEqualToValue={(option, value) => option?.value == value?.value}
                          onChange={(e, newValue) => {
                            let voucherNo = '';
                            if (newValue?.value !== '') {
                              activeVouchers.map((ele) => {
                                if (ele.serialnumber === newValue.value) {
                                  voucherNo = ele.prefix + ele.nextinvoicenumber + ele.suffix;
                                }
                              });
                              if (!voucherNo) {
                                voucherNo = newValue?.value;
                              }
                              setState((prev) => ({
                                ...prev,
                                seriesVouchers: newValue,
                                vouchernumber: voucherNo,
                              }));
                            }
                          }}
                          sx={{
                            '.css-1kxbtff-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
                              paddingBottom: '5px',
                            },
                            '.css-lcu7oo-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
                              paddingTop: '6px',
                              paddingBottom: '5px',
                              paddingLeft: '6px',
                            },
                          }}
                          size="small"
                          renderInput={(params) => (
                            <TextField
                              sx={{
                                '.css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input': {
                                  padding: '8.5px 7px',
                                },
                                '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                                  fontSize: '14px',
                                },
                                label: {
                                  fontSize: '14px',
                                },
                                '.css-lnk63-MuiButtonBase-root-MuiMenuItem-root': {
                                  fontSize: '14px',
                                },
                                '.css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root': {
                                  color: 'input.font',
                                },
                                '.css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
                                  borderColor: 'input.border',
                                },
                                '.css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root': {
                                  color: 'input.font',
                                },
                                '.css-14qz1ij-MuiListItemText-root': {
                                  margin: '0px',
                                },
                              }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              {...params}
                              label="Payment Number Series"
                            />
                          )}
                        />
                        <Typography className="error" sx={{ minHeight: '12px' }}></Typography>
                      </Box>
                    )}
                    {generalSettingsFlag === -1 ? (
                      <TextField
                        error={state.errorStatus.vouchernumber == true ? true : false}
                        name="vouchernumber"
                        label="Voucher Number"
                        size="small"
                        type="text"
                        disabled={paymentFlag == false || viewMode == true || currentPaymentFlag == true || params?.id ? true : false}
                        fullWidth
                        value={state.vouchernumber}
                        onChange={(e) => {
                          const { name, value } = e.target;
                          //  setItemCodeChange(true);
                          if (value == '') {
                            setState((prev) => ({
                              ...prev,
                              vouchernumber: value,
                              errorStatus: {
                                ...prev.errorStatus,
                                vouchernumber: true,
                              },
                              errorFields: {
                                ...prev.errorFields,
                                vouchernumber: 'Voucher Number is requierd',
                              },
                            }));
                          } else {
                            let isValid = true;
                            paymentVoucherNos.map((ele) => {
                              if (ele.VoucherNumber !== vouchNo) {
                                if (ele.VoucherNumber === value) {
                                  isValid = false;
                                }
                              }
                            });
                            if (isValid == false) {
                              setState((prev) => ({
                                ...prev,
                                vouchernumber: value,
                                errorStatus: {
                                  ...prev.errorStatus,
                                  vouchernumber: true,
                                },
                                errorFields: {
                                  ...prev.errorFields,
                                  vouchernumber: 'Voucher Number already exists',
                                },
                              }));
                            } else {
                              setState((prev) => ({
                                ...prev,
                                vouchernumber: value,
                                errorStatus: {
                                  ...prev.errorStatus,
                                  vouchernumber: false,
                                },
                                errorFields: {
                                  ...prev.errorFields,
                                  vouchernumber: '',
                                },
                              }));
                            }
                          }
                        }}
                      />
                    ) : (
                      <>
                        {/* <Box
                      sx={{
                        display: "flex",
                        justifyContent: {sm: "flex-start" },
                        alignItems: "center",
                        padding: "8px",
                        borderRadius: "4px",
                        backgroundColor: "#a0a1a11a",
                        position: "relative",
                      }}
                    >
                      <Typography
                        sx={{
                          borderRadius: "4px",
                          paddingLeft: "8px",
                          paddingRight: "8px",
                          backgroundColor: "white",
                          position: "absolute",
                          top: "-6px",
                          left: "8px",
                          color: "#808080",
                          textTransform: "capitalize",
                          fontSize: "12px",
                          fontWeight: "normal",
                        }}
                      >
                        Voucher Number
                      </Typography>
                      <Typography sx={{ color: "#808080", paddingLeft: "4px" }}>
                        {state.vouchernumber}
                      </Typography>
                    </Box> */}
                      </>
                    )}
                    {/* <Typography
                    className="error"
                    sx={{ minHeight: "12px", fontSize: "12px" }}
                  >
                    {state?.errorFields.vouchernumber}
                  </Typography> */}
                    <ToolTipComponent
                      title="Voucher Number Settings"
                      placement="top"
                      tooltipContent={
                        <Button
                          sx={{ display: 'contents' }}
                           disabled={
                            // isVoucherEditable && 
                            !viewMode && params?.id
                              ? false
                              : paymentFlag == false || viewMode == true || currentPaymentFlag == true || params?.id
                              ? true
                              : false
                          }
                          onClick={() => {
                            setSettingsModal(true);
                          }}
                        >
                          <SettingsIcon sx={{ color: '#b5b5b5', marginTop: '-12px' }} />
                        </Button>
                      }
                    />
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={3}
                  // sx={{ padding: "0px 10px" }}
                >
                  <Box sx={{ flex: { xs: 1, sm: 1 } }}>
                    <TextField
                      error={state.errorStatus.bankRefNo == true ? true : false}
                      label="Bank Reference Number"
                      id="bankRefNo"
                      disabled={
                        viewMode == true || state.method !== 'BankPayment' || (currentBankRefNo != '' && currentPaymentFlag == true)
                          ? true
                          : false
                      }
                      value={state.bankRefNo}
                      onChange={(e) => {
                        const value = e.target.value;
                        // if (value !== "" && !/^[A-Z0-9\-\/_.]{9,18}$/.test(value)) {
                        //   setState((prev) => ({
                        //     ...prev,
                        //     bankRefNo: value,
                        //     errorStatus: {
                        //       ...prev.errorStatus,
                        //       bankRefNo: true,
                        //     },
                        //     errorFields: {
                        //       ...prev.errorFields,
                        //       bankRefNo: "Invalid Bank Reference Number",
                        //     },
                        //   }));
                        // } else {
                        if (value?.length >= 255) {
                          return showWarningSnackbar('Bank reference number cannot exceed 255 characters');
                        }
                        setState((prev) => ({
                          ...prev,
                          bankRefNo: value,
                          errorStatus: {
                            ...prev.errorStatus,
                            bankRefNo: false,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            bankRefNo: '',
                          },
                        }));
                        // }
                      }}
                      fullWidth
                      size="small"
                      sx={{
                        '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                          fontSize: '14px',
                        },
                        label: {
                          fontSize: '14px',
                        },
                        '.css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root': {
                          color: 'input.font',
                        },
                        '.css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
                          borderColor: 'input.border',
                        },
                      }}
                    />
                    <Typography className="error" sx={{ minHeight: '12px', fontSize: '12px' }}>
                      {state?.errorFields.bankRefNo}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>

              <Grid item container sx={{ height: 'fit-content' }} rowSpacing={{ xs: 2, md: 0 }} columnSpacing={1}>
                <Grid item container xs={12} md={6} order={{ xs: 2, md: 1 }}>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    sx={{
                      padding: '0px 10px',
                      marginTop: '0px',
                      border: theme?.palette?.TmId.id.toString().includes('9') ? 'solid 1px white' : 'solid 1px gray',
                      borderRadius: '4px',
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: '12px',
                        fontWeight: '500px',
                        color: theme.palette.primary.main,
                        marginBottom: '2px',
                      }}
                    >
                      JOURNAL ENTRY
                    </Typography>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: { sm: 'flex-start' },
                        // alignItems:'center',
                        // padding: "8px",

                        // backgroundColor: theme.palette.background.tablebg,

                        // border: "solid 1px black",
                        color: '#595C66',
                        minHeight: '150px',
                        position: 'relative',
                        maxWidth: '100%',
                        overflow: 'scroll',
                        '&:hover': {
                          cursor: 'pointer',
                        },
                        scrollbarWidth: 'none',
                        '&::-webkit-scrollbar': {
                          display: 'none',
                        },
                        boxSizing: 'content-box',
                      }}
                    >
                      <div dangerouslySetInnerHTML={{ __html: journalHTML }} />
                    </Box>
                  </Grid>
                  <Grid
                    xs={12}
                    md={12}
                    sx={{
                      textAlign: 'right',
                      // paddingRight: "15px",
                      // paddingLeft: "8px",
                      marginTop: { xs: '10px', md: '10px' },
                      position: 'relative',
                      top: '0px',
                    }}
                  >
                    <TeaxtareaField
                      name="remarks"
                      placeholder="Narration"
                      size="small"
                      fullWidth
                      rows={4}
                      maxLength={251}
                      value={state.remarks}
                      disabled={paymentFlag === false || viewMode === true || currentPaymentFlag === true}
                      onChange={(e) => {
                        const value = e.target.value;

                        if (value.length > 250) {
                          setState((prev) => ({
                            ...prev,
                            remarks: value,
                            errorStatus: {
                              ...prev.errorStatus,
                              narration: true,
                            },
                            errorFields: {
                              ...prev.errorFields,
                              narration: 'Narration must be less than 250 characters',
                            },
                          }));
                        } else {
                          setState((prev) => ({
                            ...prev,
                            remarks: value,
                            errorStatus: {
                              ...prev.errorStatus,
                              narration: false,
                            },
                            errorFields: {
                              ...prev.errorFields,
                              narration: '',
                            },
                          }));
                        }
                      }}
                      sx={{
                        '.MuiInputBase-root': {
                          fontSize: '14px',
                          height: '100%',
                        },
                        '.MuiFormLabel-root': {
                          fontSize: '14px',
                          color: 'input.font',
                        },
                        '.MuiOutlinedInput-notchedOutline': {
                          borderColor: 'input.border',
                        },
                        '.MuiGrid-root': {
                          height: '100%',
                        },
                      }}
                    />
                    {state.errorStatus.narration && (
                      <Typography
                        sx={{
                          color: 'red',
                          fontSize: '12px',
                          marginTop: '4px',
                          textAlign: 'right',
                        }}
                      >
                        {state.errorFields.narration}
                      </Typography>
                    )}
                  </Grid>
                </Grid>
                <Grid item container xs={12} md={6} rowSpacing={{ xs: 1, md: 0 }} order={{ xs: 1, md: 2 }}>
                  <Grid
                    item
                    xs={7}
                    sm={8}
                    sx={{
                      display: 'flex',
                      alignItems: 'left',
                      fontSize: '12px',
                      margin: '',
                    }}
                  >
                    <Box sx={{ flex: { xs: 1 } }}>
                      <AccountInputv2
                        filter={[7]}
                        error={state?.errorStatus?.paidTo}
                        id="paidTo"
                        key={AllAccountsListing.length}
                        label={'Paid To'}
                        addAccountModal={() => {
                          setNewPartyID('');
                          setAccountFlag(false);
                          setFromAccountModal(true);
                          setOpenModalEvent(true);
                        }}
                        options={AllAccountsListing}
                        disabled={paymentFlag == false || viewMode == true || currentPaymentFlag == true || params.partyID ? true : false}
                        isOptionEqualToValue={(option, value) => option.value == value.value}
                        value={state.paidTo}
                        onChange={(e, newValue) => {
                          setvouchers([]);
                          if (newValue?.AccountTypeFlag == 1 || newValue?.AccountTypeFlag == 2) {
                            getTransactions(newValue.value);
                          }
                          if (!newValue) {
                            setState((prev) => ({
                              ...prev,
                              paidTo: { label: '', value: '' },
                              tdsApplicable: '',
                              tdsAmount: '',
                              TDSPercentage: '',
                              errorStatus: {
                                ...prev.errorStatus,
                                paidTo: true,
                                tdsApplicable: false,
                                tdsAmount: false,
                                TDSPercentage: false,
                              },
                              errorFields: {
                                ...prev.errorFields,
                                paidTo: '',
                                tdsApplicable: '',
                                tdsAmount: '',
                                TDSPercentage: '',
                              },
                            }));
                          } else if (newValue === '') {
                            setState((prev) => ({
                              ...prev,
                              paidTo: newValue,
                              errorStatus: {
                                ...prev.errorStatus,
                                paidTo: true,
                              },
                              errorFields: {
                                ...prev.errorFields,
                                paidTo: ' Paid To Field Is required',
                              },
                            }));
                          } else if (newValue.value !== '' && state.paidFrom.value !== '') {
                            setAccountID(newValue.value);
                            if (newValue.value == state.paidFrom.value) {
                              setState((prev) => ({
                                ...prev,
                                paidTo: newValue,

                                errorStatus: {
                                  ...prev.errorStatus,
                                  paidTo: true,
                                },
                                errorFields: {
                                  ...prev.errorFields,
                                  paidTo: ' Paid From and Paid To should be different',
                                },
                              }));
                            } else {
                              let accType = '';
                              AllAccountsListing.map((ele) => {
                                if (ele.AccountsID === newValue.value) {
                                  accType = ele.AccountGroupID;
                                }
                              });
                              if (newValue.AccountTypeFlag == 1 || newValue.AccountTypeFlag == 2) {
                                setAccountType(accType);
                                setState((prev) => ({
                                  ...prev,
                                  paidTo: newValue,
                                  tdsApplicable: newValue.TDSSection ? newValue.TDSSection : '',
                                  TDSPercentage: newValue.TDSPercentage ? newValue.TDSPercentage : '',
                                  tdsAmount: prev.payableAmount ? (prev.payableAmount * newValue.TDSPercentage) / 100 : '',
                                  errorStatus: {
                                    ...prev.errorStatus,
                                    paidTo: false,
                                    paidFrom: false,
                                    tdsApplicable: false,
                                    tdsAmount: false,
                                    TDSPercentage: false,
                                  },
                                  errorFields: {
                                    ...prev.errorFields,
                                    paidTo: '',
                                    paidFrom: '',
                                    tdsApplicable: '',
                                    tdsAmount: '',
                                    TDSPercentage: '',
                                  },
                                }));
                              } else {
                                if (state.tdsAmount || state.tdsApplicable) {
                                  showWarningSnackbar('TDS is applicable only for customer or supplier !');
                                }
                                setState((prev) => ({
                                  ...prev,
                                  paidTo: newValue,
                                  tdsApplicable: '',
                                  tdsAmount: '',
                                  TDSPercentage: '',
                                  errorStatus: {
                                    ...prev.errorStatus,
                                    paidTo: false,
                                    tdsApplicable: false,
                                    tdsAmount: false,
                                    TDSPercentage: false,
                                  },
                                  errorFields: {
                                    ...prev.errorFields,
                                    paidTo: '',
                                    tdsApplicable: '',
                                    tdsAmount: '',
                                    TDSPercentage: '',
                                  },
                                }));
                              }
                            }
                          } else {
                            setState((prev) => ({
                              ...prev,
                              paidTo: newValue,
                              errorStatus: {
                                ...prev.errorStatus,
                                paidTo: false,
                              },
                              errorFields: {
                                ...prev.errorFields,
                                paidTo: '',
                              },
                            }));
                          }
                        }}
                        onKeyDown={(e) => {
                          handleKeyDown(e);
                        }}
                      />
                      {state?.errorFields.paidTo?.length ? (
                        <Typography className="error" sx={{ minHeight: '12px', fontSize: '12px' }}>
                          {state?.errorFields.paidTo}
                        </Typography>
                      ) : (
                        ''
                      )}
                      <Typography
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          paddingRight: '4px',
                          flexDirection: 'column-reverse',
                          '& .MuiTypography-root': {
                            fontSize: { xs: '10px', lg: '12px' },
                          },
                        }}
                      >
                        {state.paidTo.value !== '' && state.errorStatus.paidTo == false && (
                          <Typography
                            sx={{
                              justifyContent: 'flex-end',
                              color:
                                viewMode == true || paymentFlag == false
                                  ? 'input.border'
                                  : Number(toBalanceAmount || 0) -
                                      (params?.id && amountsFromTable?.paidFrom?.value == state.paidFrom.value
                                        ? Number(amountsFromTable.payableAmount - state.payableAmount) > 0
                                          ? Number(amountsFromTable.payableAmount - state.payableAmount) * -1
                                          : Number(amountsFromTable.payableAmount - state.payableAmount) * -1
                                        : Number(state.payableAmount)) <
                                    0
                                  ? ''
                                  : Number(toBalanceAmount || 0) -
                                      (params?.id
                                        ? Number(amountsFromTable.payableAmount - state.payableAmount) > 0
                                          ? Number(amountsFromTable.payableAmount - state.payableAmount) * -1
                                          : Number(amountsFromTable.payableAmount - state.payableAmount) * -1
                                        : Number(state.payableAmount)) >
                                    0
                                  ? 'danger.main'
                                  : 'primary.main',
                              display: 'flex',
                              // flexDirection: { xs: 'column', sm: 'row' },
                              alignItems: { xs: 'flex-start', sm: 'center' },
                              fontSize: '10px',
                              marginTop: { xs: '0px' },
                            }}
                          >
                            Balance :
                            <a
                              className="myLink"
                              disabled={viewMode == true ? true : false}
                              // color={
                              //   viewMode == true ? "input.border" : "primary.main"
                              // }

                              sx={{
                                textDecoration: 'underline',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: viewMode == true ? 'default' : 'pointer',
                                fontSize: '13px',
                              }}
                              // onClick={(event) => event.preventDefault()}
                              href={`/LedgerTransactions/${state?.paidTo?.value}`}
                              onClick={(e) => {
                                e.preventDefault();
                                setAccountIDTransaction(state?.paidTo?.value);
                              }}
                            >
                              {' '}
                              ₹{' '}
                              {/* {Number(toBalanceAmount) + (params?.id ? Number(amountsFromTable.payableAmount - state.payableAmount) > 0 ? Number(amountsFromTable.payableAmount - state.payableAmount) *-1 : Number(amountsFromTable.payableAmount - state.payableAmount) *-1 : Number(state.payableAmount)) }--- */}
                              {/* {toBalanceAmount} {JSON.stringify(amountsFromTable)} */}
                              {/* total  {Number(toBalanceAmount)} , */}
                              {/* <b style={{ "color": "red" }}>{Number(toBalanceAmount) + (params?.id ? (Number(amountsFromTable.payableAmount - state.payableAmount)) : Number(state.payableAmount))}
                            </b> */}
                              {Number(toBalanceAmount || 0) -
                                (params?.id && amountsFromTable?.paidFrom?.value == state.paidFrom.value
                                  ? Number(amountsFromTable.payableAmount - state.payableAmount) > 0
                                    ? Number(amountsFromTable.payableAmount - state.payableAmount) * -1
                                    : Number(amountsFromTable.payableAmount - state.payableAmount) * -1
                                  : Number(state.payableAmount)) <
                              0
                                ? MoneyFormatv3(
                                    (Number(toBalanceAmount || 0) -
                                      (params?.id && amountsFromTable?.paidFrom?.value == state.paidFrom.value
                                        ? Number(amountsFromTable.payableAmount - state.payableAmount) > 0
                                          ? Number(amountsFromTable.payableAmount - state.payableAmount) * -1
                                          : Number(amountsFromTable.payableAmount - state.payableAmount) * -1
                                        : Number(state.payableAmount))) *
                                      -1
                                  ) + ' (Dr)'
                                : Number(toBalanceAmount || 0) -
                                    (params?.id && amountsFromTable?.paidFrom?.value == state.paidFrom.value
                                      ? Number(amountsFromTable.payableAmount - state.payableAmount) > 0
                                        ? Number(amountsFromTable.payableAmount - state.payableAmount) * -1
                                        : Number(amountsFromTable.payableAmount - state.payableAmount) * -1
                                      : Number(state.payableAmount)) >
                                  0
                                ? MoneyFormatv3(
                                    Number(toBalanceAmount || 0) -
                                      (params?.id && amountsFromTable?.paidFrom?.value == state.paidFrom.value
                                        ? Number(amountsFromTable.payableAmount - state.payableAmount) > 0
                                          ? Number(amountsFromTable.payableAmount - state.payableAmount) * -1
                                          : Number(amountsFromTable.payableAmount - state.payableAmount) * -1
                                        : Number(state.payableAmount))
                                  ) + ' (Cr)'
                                : (0).toFixed(2)}
                              {/* {toBalanceAmount}-{amountsFromTable.payableAmount}-{
                                            state.payableAmount} */}
                            </a>
                          </Typography>
                        )}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs={5}
                    sm={4}
                    sx={{
                      display: 'flex',
                      alignItems: 'left',
                      fontSize: '12px',
                      margin: '',
                      paddingRight: '10px',
                    }}
                  >
                    <Box sx={{ flex: { xs: 1, sm: 1 } }}>
                      <MoneyInput
                        state={state}
                        value={state.payableAmount}
                        onKeyDown={handleKeyDownn}
                        onChange={(e) => {
                          let value = e;
                          value = value.replace(/,/g, '');
                          if (value >= 10000000000) {
                            showWarningSnackbar('Payable amount must be less than ₹1000 crore');
                            return;
                          }
                          if (!/^\d*(?:\.\d*)?$/.test(value)) {
                            return;
                          }
                          if (/^\d*\.?\d{0,2}$/.test(value) == false) {
                            return;
                          }

                          let amount = 0;
                          if (state.tdsApplicable !== '') {
                            // amount = (value / 100) * state.tdsApplicable;
                            amount = Number(state.TDSPercentage * value) / 100;
                          } else {
                            amount = 0;
                          }
                          if (value == '' && state.paidTo.value) {
                            setState((prev) => ({
                              ...prev,
                              payableAmount: value,
                              tdsAmount: prev.TDSManual ? prev.tdsAmount : amount,
                              errorStatus: {
                                ...prev.errorStatus,
                                payableAmount: true,
                              },
                              errorFields: {
                                ...prev.errorFields,
                                payableAmount: 'Amount Payable field is required',
                              },
                            }));
                          } else {
                            setState((prev) => ({
                              ...prev,
                              payableAmount: value,
                              tdsAmount: prev.TDSManual ? prev.tdsAmount : `${amount}`,
                              errorStatus: {
                                ...prev.errorStatus,
                                payableAmount: false,
                                tdsAmount: false,
                              },
                              errorFields: {
                                ...prev.errorFields,
                                payableAmount: '',
                                tdsAmount: '',
                              },
                            }));
                          }
                        }}
                        label="Payable Amount"
                        id="payableAmount"
                        name="payableAmount"
                        variant="outlined"
                        disabled={paymentFlag == false || viewMode === true || currentPaymentFlag == true ? true : false}
                      />

                      <Typography className="error" sx={{ minHeight: '12px', fontSize: '12px' }}>
                        {state?.errorFields.payableAmount}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={6} sx={{ padding: '0px' }}>
                    <Autocomplete
                      openOnFocus
                      label="Less TDS Applicable"
                      name="tdsApplicable"
                      id="tdsApplicable"
                      filterOptions={filterOptions}
                      options={tdsSection}
                      value={state.tdsApplicable}
                      PaperComponent={({ children }) => <Paper style={{ width: 'fit-content', minWidth: '100%' }}>{children}</Paper>}
                      getOptionLabel={(value) => {
                        return tdsSection.find((option) => option.section == value)?.option || '';
                      }}
                      // getOptionLabel={(option) => {
                      //   return option.section || '';
                      // }}
                      isOptionEqualToValue={(option, value) => option.section == value}
                      disabled={
                        paymentFlag == false ||
                        viewMode === true ||
                        currentPaymentFlag == true ||
                        (state.paidTo.AccountTypeFlag != 2 && state.paidTo.AccountTypeFlag != 1)
                          ? true
                          : false
                      }
                      onChange={(e, newValue) => {
                        const value = newValue?.section;
                        let codeValue = newValue?.value ? newValue?.value : 0;
                        // tdsSection.map((ele) => {
                        //   if (ele.section == value) {
                        //     codeValue = ele.value;
                        //   }
                        // });
                        let amount = Number(((state.payableAmount / 100) * codeValue).toFixed(2));

                        if (!value) {
                          setState((prev) => ({
                            ...prev,
                            tdsApplicable: '',
                            TDSPercentage: 0,
                            tdsAmount: 0,
                            TDSManual: 0,
                            errorStatus: {
                              ...prev.errorStatus,
                              tdsApplicable: true,
                            },
                            errorFields: {
                              ...prev.errorFields,
                              tdsApplicable: '',
                            },
                          }));
                        } else if (value == '') {
                          setState((prev) => ({
                            ...prev,
                            tdsApplicable: value,
                            TDSPercentage: codeValue,
                            tdsAmount: 0,
                            TDSManual: 0,
                            errorStatus: {
                              ...prev.errorStatus,
                              tdsApplicable: true,
                            },
                            errorFields: {
                              ...prev.errorFields,
                              tdsApplicable: ' TDS Applicable Field is required',
                            },
                          }));
                        } else {
                          setState((prev) => ({
                            ...prev,
                            tdsApplicable: value,
                            tdsAmount: `${amount}`,
                            TDSManual: 0,
                            TDSPercentage: codeValue,
                            errorStatus: {
                              ...prev.errorStatus,
                              tdsApplicable: false,
                              tdsAmount: false,
                            },
                            errorFields: {
                              ...prev.errorFields,
                              tdsApplicable: '',
                              tdsAmount: '',
                            },
                          }));
                        }
                      }}
                      size="small"
                      renderOption={(props, option) => (
                        <>
                          <MenuItem {...props} key={option.value} value={option.section}>
                            <ListItemText primary={option.option} />
                          </MenuItem>
                        </>
                      )}
                      renderInput={(params) => (
                        <TextField
                          sx={{
                            '& .MuiAutocomplete-popup': {
                              width: 'auto', // Adjust this to meet the width requirement
                              maxWidth: '100%', // Ensure it does not overflow the viewport
                            },
                            '.css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input': {
                              padding: '8.5px 7px',
                            },
                            '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                              fontSize: '14px',
                            },
                            label: {
                              fontSize: '14px',
                            },
                            '.css-lnk63-MuiButtonBase-root-MuiMenuItem-root': {
                              fontSize: '14px',
                            },
                            '.css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root': {
                              color: 'input.font',
                            },
                            '.css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
                              borderColor: 'input.border',
                            },
                            '.css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root': {
                              color: 'input.font',
                            },
                            '.css-14qz1ij-MuiListItemText-root': {
                              margin: '0px',
                            },
                            '.css-wgai2y-MuiFormLabel-asterisk': {
                              color: 'danger.main',
                            },
                            '& .MuiAutocomplete-endAdornment svg': {
                              color: 'black',
                            },
                          }}
                          label={'Less TDS Applicable'}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          {...params}
                        />
                      )}
                    />

                    <Typography
                      sx={{
                        marginTop: '2px',
                        marginLeft: '10px',
                        marginBottom: '0px',
                        fontSize: '11px',
                        color: 'danger.main',
                      }}
                    >
                      {state?.errorFields.tdsApplicable}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sm={2}
                    sx={{
                      padding: '0px 0px',
                      // marginTop: "10px",
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <Box>
                      <TextField
                        error={state.errorStatus.TDSPercentage == true ? true : false}
                        value={state.TDSPercentage}
                        required={state.tdsAmount ? true : false}
                        disabled={
                          paymentFlag == false ||
                          viewMode == true ||
                          currentPaymentFlag == true ||
                          (state.paidTo.AccountTypeFlag != 2 && state.paidTo.AccountTypeFlag != 1) ||
                          !state.tdsApplicable
                            ? true
                            : false
                        }
                        onChange={(e) => {
                          let value = e.target.value;
                          let tdsAmount = 0;
                          tdsAmount = (Number(state.payableAmount) * Number(value)) / 100;
                          value = value?.replace(/,/g, '');
                          if (!/^\d*(?:\.\d*)?$/.test(value)) {
                            return;
                          }
                          if (value == '') {
                            setState((prev) => ({
                              ...prev,
                              TDSPercentage: value,
                              TDSManual: 0,
                              tdsAmount,
                              errorStatus: {
                                ...prev.errorStatus,
                                TDSPercentage: false,
                                tdsAmount: false,
                              },
                              errorFields: {
                                ...prev.errorFields,
                                TDSPercentage: '',
                                tdsAmount: '',
                              },
                            }));
                          } else {
                            setState((prev) => ({
                              ...prev,
                              TDSPercentage: value,
                              TDSManual: 0,
                              tdsAmount,
                              errorStatus: {
                                ...prev.errorStatus,
                                TDSPercentage: false,
                                tdsAmount: false,
                              },
                              errorFields: {
                                ...prev.errorFields,
                                TDSPercentage: '',
                                tdsAmount: '',
                              },
                            }));
                          }
                        }}
                        onKeyDown={handleTdsPercent}
                        id="tdsAmount"
                        label={'TDS'}
                        variant="outlined"
                        size="small"
                        fullWidth
                        sx={{
                          flex: 1,
                          '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                            fontSize: '14px',
                          },
                          label: {
                            fontSize: '14px',
                          },
                          '.css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root': {
                            color: 'input.font',
                          },
                          '.css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
                            borderColor: 'input.border',
                          },
                          '.css-12veg18-MuiInputBase-root-MuiOutlinedInput-root': {
                            height: '100%',
                          },
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <PercentIcon fontSize="14px" />
                            </InputAdornment>
                          ),
                          style: { height: '100%' },
                        }}
                      />
                      <Typography
                        sx={{
                          marginTop: '2px',
                          marginLeft: '10px',
                          marginBottom: '0px',
                          fontSize: '11px',
                          color: 'danger.main',
                          height: '12px',
                        }}
                      >
                        {state?.errorFields.TDSPercentage}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sm={4}
                    id="jik"
                    sx={{
                      padding: { xs: '0px', lg: '0px 10px 0px 0px' },
                      marginTop: { xs: '0px', lg: '-10px' },
                      fontSize: '12px',
                      textAlign: 'right',
                      // margin: "auto",
                      paddingTop: { xs: '0px', lg: '10px !important' },
                    }}
                  >
                    <MoneyInput
                      state={state}
                      value={state.tdsAmount}
                      onChange={(e) => {
                        let value = e;
                        value = value.replace(/,/g, '');

                        if (!/^\d*(?:\.\d*)?$/.test(value)) {
                          return;
                        }
                        if (/^\d*\.?\d{0,2}$/.test(value) == false) {
                          return;
                        }

                        let amount = 0;
                        if (state.tdsApplicable !== '') {
                          // amount = (value / 100) * state.tdsApplicable;
                          amount = Number(state.TDSPercentage * value) / 100;
                        } else {
                          amount = 0;
                        }
                        if (value == '') {
                          setState((prev) => ({
                            ...prev,
                            tdsAmount: value,
                            TDSManual: 1,
                            errorStatus: {
                              ...prev.errorStatus,
                              payabltdsAmounteAmount: true,
                            },
                            errorFields: {
                              ...prev.errorFields,
                              tdsAmount: 'TDS Amount is required',
                            },
                          }));
                        } else if (parseFloat(value) > parseFloat(state.payableAmount || 0)) {
                          setState((prev) => ({
                            ...prev,
                            // tdsAmount: value,
                            TDSManual: 1,
                            errorStatus: {
                              ...prev.errorStatus,
                              tdsAmount: true,
                            },
                            errorFields: {
                              ...prev.errorFields,
                              tdsAmount: 'TDS is greater than payable amount',
                            },
                          }));
                        } else {
                          setState((prev) => ({
                            ...prev,
                            tdsAmount: value,
                            TDSManual: 1,
                            errorStatus: {
                              ...prev.errorStatus,
                              tdsAmount: false,
                            },
                            errorFields: {
                              ...prev.errorFields,
                              tdsAmount: '',
                            },
                          }));
                        }
                      }}
                      onKeyDown={handleTdsKeydown}
                      label="TDS Amount"
                      id="TDSAmount"
                      name="tdsAmount"
                      variant="outlined"
                      disabled={
                        paymentFlag == false ||
                        viewMode === true ||
                        currentPaymentFlag == true ||
                        !state.tdsApplicable ||
                        (state.paidTo.AccountTypeFlag != 2 && state.paidTo.AccountTypeFlag != 1)
                          ? true
                          : false
                      }
                    />
                    <Typography className="error" sx={{ minHeight: '12px', fontSize: '12px' }}>
                      {state?.errorFields.tdsAmount}
                    </Typography>
                    {/* ₹ {MoneyFormatv3(state.tdsAmount)} */}
                  </Grid>

                  <Grid item container xs={12} sx={{ padding: '0px ' }}>
                    <Grid item xs={8}>
                      <AccountInput
                        error={state?.errorFields.paidFrom}
                        label={`Amount Paid From ${state.method == 'CashPayment' ? 'Cash' : 'Bank'} Account`}
                        id="paidFrom"
                        options={state.method == 'CashPayment' ? CashAccountsListing : BankAccountsListing}
                        disabled={paymentFlag == false || viewMode == true || currentPaymentFlag == true ? true : false}
                        isOptionEqualToValue={(option, value) => option.value == value.value}
                        value={state.paidFrom}
                        addAccountModal={() => {
                          setAccountFlag(true);
                          if (state.method === 'BankPayment') {
                            setOpenBankModal(true);
                          } else {
                            setNewPartyID('');
                            setFromAccountModal(true);
                            setOpenModalEvent(true);
                          }
                        }}
                        onChange={(e, newValue) => {
                          if (!newValue) {
                            setState((prev) => ({
                              ...prev,
                              paidFrom: { label: '', value: '' },
                              errorStatus: {
                                ...prev.errorStatus,
                                paidFrom: true,
                              },
                              errorFields: {
                                ...prev.errorFields,
                                paidFrom: '',
                              },
                            }));
                          } else if (newValue === '') {
                            setState((prev) => ({
                              ...prev,
                              paidFrom: newValue,
                              errorStatus: {
                                ...prev.errorStatus,
                                paidFrom: true,
                              },
                              errorFields: {
                                ...prev.errorFields,
                                paidFrom: ' Paid From Field Is required',
                              },
                            }));
                          } else if (newValue.value !== '' && state.paidTo.value !== '') {
                            if (newValue.value == state.paidTo.value) {
                              setState((prev) => ({
                                ...prev,
                                paidFrom: newValue,
                                errorStatus: {
                                  ...prev.errorStatus,
                                  paidFrom: true,
                                },
                                errorFields: {
                                  ...prev.errorFields,
                                  paidFrom: ' Paid From and Paid To should be different',
                                },
                              }));
                            } else {
                              setState((prev) => ({
                                ...prev,
                                paidFrom: newValue,
                                errorStatus: {
                                  ...prev.errorStatus,
                                  paidFrom: false,
                                  paidTo: false,
                                },
                                errorFields: {
                                  ...prev.errorFields,
                                  paidFrom: '',
                                  paidTo: '',
                                },
                              }));
                            }
                          } else {
                            let accType = '';
                            AllAccountsListing.map((ele) => {
                              if (ele.accountsid === newValue.value) {
                                accType = ele.accountgroupid;
                              }
                            });
                            setAccountType(accType);
                            setState((prev) => ({
                              ...prev,
                              paidFrom: newValue,
                              errorStatus: {
                                ...prev.errorStatus,
                                paidFrom: false,
                              },
                              errorFields: {
                                ...prev.errorFields,
                                paidFrom: '',
                              },
                            }));
                          }
                        }}
                      />

                      {state?.errorFields.paidFrom ? (
                        <Typography className="error" sx={{ minHeight: '12px', fontSize: '12px' }}>
                          {state?.errorFields.paidFrom}
                        </Typography>
                      ) : (
                        ''
                      )}

                      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        {state.paidFrom.value !== '' && state.errorStatus.paidFrom == false && (
                          <Typography
                            sx={{
                              // justifyContent: "flex-end",
                              color:
                                viewMode == true || paymentFlag == false
                                  ? 'input.border'
                                  : (params?.id && amountsFromTable?.paidFrom?.value == state.paidFrom.value
                                      ? calculateBalance(
                                          (fromBalanceAmount || 0) +
                                            (Number(amountsFromTable.payableAmount) -
                                              Number(amountsFromTable.tdsAmount) -
                                              (Number(state.payableAmount) - Number(state.tdsAmount ?? 0))) *
                                              -1
                                        )
                                      : calculateBalance(
                                          (fromBalanceAmount || 0) + (Number(state.payableAmount) - Number(state.tdsAmount ?? 0))
                                        )
                                    )?.includes('Cr')
                                  ? 'danger.main'
                                  : 'primary.main',
                              display: 'flex',
                              alignItems: 'center',
                              // fontSize: '12px',
                              '&.MuiTypography-root': {
                                fontSize: { xs: '10px', lg: '12px' },
                              },
                              // width:"300px"
                              // marginTop: { xs: "5px" },
                            }}
                          >
                            {(params?.id && amountsFromTable?.paidFrom?.value == state.paidFrom.value
                              ? calculateBalance(
                                  (fromBalanceAmount || 0) +
                                    (Number(amountsFromTable.payableAmount) -
                                      Number(amountsFromTable.tdsAmount) -
                                      (Number(state.payableAmount) - Number(state.tdsAmount ?? 0))) *
                                      -1
                                )
                              : calculateBalance((fromBalanceAmount || 0) + (Number(state.payableAmount) - Number(state.tdsAmount ?? 0)))
                            )?.includes('Cr')
                              ? state.paidFrom.label + ' ' + 'Balance is negative'
                              : ''}
                          </Typography>
                        )}
                        {state.paidFrom.value !== '' && state.errorStatus.paidFrom == false && (
                          <Typography
                            sx={{
                              // justifyContent: "flex-end",
                              color:
                                viewMode == true || paymentFlag == false
                                  ? 'input.border'
                                  : (params?.id && amountsFromTable?.paidFrom?.value == state.paidFrom.value
                                      ? calculateBalance(
                                          (fromBalanceAmount || 0) +
                                            (Number(amountsFromTable.payableAmount) -
                                              Number(amountsFromTable.tdsAmount) -
                                              (Number(state.payableAmount) - Number(state.tdsAmount ?? 0))) *
                                              -1
                                        )
                                      : calculateBalance(
                                          (fromBalanceAmount || 0) + (Number(state.payableAmount) - Number(state.tdsAmount ?? 0))
                                        )
                                    )?.includes('Cr')
                                  ? 'danger.main'
                                  : 'primary.main',
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: { xs: 'flex-start', sm: 'center' },
                              fontSize: '12px',
                              textWrap: 'nowrap',
                              '&.MuiTypography-root': {
                                fontSize: { xs: '10px', lg: '12px' },
                              },
                              // marginTop: { xs: "-5px" },
                            }}
                          >
                            Balance :
                            <a
                              className="myLink"
                              href={`/LedgerTransactions/${state?.paidFrom?.value}`}
                              onClick={(e) => {
                                e.preventDefault();
                                setAccountIDTransaction(state.paidFrom?.value);
                              }}
                              disabled={viewMode == true ? true : false}
                              // color={
                              //   viewMode == true || paymentFlag == false
                              //     ? "input.border"
                              //     : "primary.main"
                              // }

                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                // color:
                                //   viewMode == true
                                //     ? "input.border"
                                //     : fromBalanceAmount -
                                //       (params?.id
                                //         ? Number(
                                //           amountsFromTable.payableAmount -
                                //           amountsFromTable.tdsAmount -
                                //           (state.payableAmount -
                                //             state.tdsAmount ?? 0)
                                //         )
                                //         : Number(
                                //           state.payableAmount -
                                //           state.tdsAmount ?? 0
                                //         )) <
                                //       0
                                //       ? "danger.main"
                                //       : "primary.main",
                                fontSize: '13px',
                              }}
                            >
                              ₹{' '}
                              {params?.id && amountsFromTable?.paidFrom?.value == state.paidFrom.value
                                ? calculateBalance(
                                    (fromBalanceAmount || 0) +
                                      (Number(amountsFromTable.payableAmount) -
                                        Number(amountsFromTable.tdsAmount) -
                                        (Number(state.payableAmount) - Number(state.tdsAmount ?? 0))) *
                                        -1
                                  )
                                : calculateBalance((fromBalanceAmount || 0) + (Number(state.payableAmount) - Number(state.tdsAmount ?? 0)))}
                            </a>
                          </Typography>
                        )}
                      </Box>
                    </Grid>
                    <Grid item xs={4} sx={{ padding: '0px 15px' }}>
                      {/* <Grid
                item
                xs={4}
                sx={{ padding: "0px 10px", marginTop: "15px",  }}
              > */}
                      <Typography
                        component="div"
                        sx={{
                          fontSize: '13px',
                          textAlign: 'right',
                          fontWeight: 'bold',
                        }}
                      >
                        {' '}
                        ₹&nbsp;
                        {state.payableAmount
                          ? MoneyFormatv3(Number(Number(state.payableAmount) - Number(state.tdsAmount))?.toFixed(2))
                          : '0.00'}
                      </Typography>
                      {/* </Grid> */}
                    </Grid>
                  </Grid>

                  <Grid item xs={12}>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                        marginBottom: '20px',
                        gap: '10px',
                        // marginTop: "10px",
                      }}
                    >
                      <TextField
                        variant="outlined"
                        size="small"
                        fullWidth
                        label="Towards"
                        value={state.Towards}
                        onChange={(e) => {
                          setState((prev) => ({
                            ...prev,
                            Towards: e.target.value,
                          }));
                        }}
                        sx={{
                          width: '50%',
                        }}
                        disabled={viewMode == true || currentPaymentFlag == true ? true : false}
                      />
                      {state.Towards ? (
                        <>
                          <Typography
                            sx={{
                              fontSize: '13px',
                              color: theme?.palette?.TmId.id.toString().includes('9') ? 'rgba(126, 126, 126, 0.54)' : 'rgba(0, 0, 0, 0.5)',
                            }}
                          >
                            This will be displayed on the receipt
                          </Typography>
                        </>
                      ) : null}
                    </Box>
                  </Grid>
                </Grid>
              </Grid>

              <Grid container item sx={{ marginTop: '24px', marginBottom: '0px', marginLeft: '0px' }}>
                <Grid
                  item
                  container
                  xs={12}
                  md={6}
                  style={
                    {
                      // justifyContent: { xs: "center", lg: "flex-start" },
                    }
                  }
                  sx={{ display: { xs: 'block', lg: 'flex' } }}
                >
                  {/* <Grid item lg={1} xs={12}> */}
                  <Typography
                    sx={{
                      marginRight: '10px',
                      fontWeight: 'bold',
                      marginBottom: '5px',
                      color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                    }}
                    variant="h2"
                  >
                    Documents
                  </Typography>
                  {/* </Grid> */}
                  {/* <Grid lg={3} xs={12}> */}
                  {/* <div> */}
                  <input
                    ref={imageRef}
                    type="file"
                    id="fileInput"
                    onChange={handleFileChange}
                    multiple
                    style={{ display: 'none' }}
                    accept="
                      application/msword,
                      application/pdf,
                      application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                      application/vnd.ms-excel,
                      application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                      application/vnd.ms-powerpoint,
                      application/vnd.openxmlformats-officedocument.presentationml.presentation,
                      image/jpeg,
                      image/jpg,
                      image/png
                    "
                  />

                  <CustomTooltip title="Rolling out soon" placement="top">
                    <span>
                      <Button
                        onClick={() => imageRef?.current?.click()}
                        size="small"
                        variant="contained"
                        // disabled={viewPage}
                        // disabled={params?.view}
                        disabled={true}
                        sx={{
                          fontSize: '12px',
                          padding: '5px 7px',
                          marginBottom: '5px',
                          boxShadow: 'none',
                          marginTop: '-3px',
                          display: params?.view ? 'none' : 'block',
                        }}
                      >
                        <span>
                          <AddIcon fontSize="15px" />
                          ADD DOCUMENT
                        </span>
                        {attachments.length > 0 && <span style={{ color: 'white' }}>{'\xa0' + `(${attachments.length} out of 6)`}</span>}
                      </Button>
                    </span>
                  </CustomTooltip>

                  {/* </div> */}
                  {/* </Grid> */}

                  {attachments.length > 0 && (
                    <Grid lg={12}>
                      <Attachment
                        view={params?.view}
                        attachments={attachments}
                        setAttachments={setAttachments}
                        updateAttachmentName={updateAttachmentName}
                      />
                    </Grid>
                  )}
                </Grid>
                {vouchers.length > 0 && (
                  <>
                    <Grid xs={12} md={6} sx={{ textAlign: 'right', paddingRight: '15px' }}>
                      <LinkingTable
                        type="payment"
                        key={'link'}
                        disabled={paymentFlag == false || viewMode == true || currentPaymentFlag == true ? true : false}
                        data={vouchers}
                        onChange={handleLinkedAmount}
                      />
                      <Typography sx={{ marginTop: '5px' }}>Balance in Payment : {MoneyFormatv3(balanceInReceipt())}</Typography>
                    </Grid>
                  </>
                )}
                {Enable_ItemWiseEntry ? <Grid item md={12} sx={{ padding: '0px 10px', marginTop: '10px' }}></Grid> : ''}
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>

      {/* <FloatingButton
        setCancelModal={setCancelModal}
        saveChanges={() => {
          saveChanges({ new: false });
        }}
        saveChangesPrint={() => {
          saveChanges({ print: true, preview: false });
          // handlePrint(state.vouchernumber)
        }}
        saveEditChanges={() => saveEditChanges()}
        saveandNew={() => saveChanges({ new: true })}
        saveChangesFlag={true}
        isModal={modalEvent}
        setPreviewModal={setPreviewPaymentModal}
        previewLabel="Preview Invoice"
        printButton={true}
        paramsID={params?.id}
        paramsView={params?.view}
        onPrint={handlePrint}
      /> */}
      {/* {(viewMode == true ? entryData?.cancelflag === 0 : true) ? ( */}
      <DraggableAction
        actionType={params?.id && params?.view !== true ? 'edit' : entryData?.cancelflag === 1 ? 'cancelled' : 'save'}
        from={'payment'}
        onExit={() => {
          navigate('/paymententries');
        }}
        onSave={
          params?.id && params?.view !== true
            ? () => {
                saveEditChanges();
              }
            : params?.view !== true
            ? () => saveChanges({ new: false })
            : null
        }
        onEnableEdit={() => {
          navigate('/editpaymententries', {
            state: { id: entryData.transactionid },
          });
        }}
        onPrint={params?.view == true || params?.id ? () => fetchAndPrintPDF(uri) : null}
        onCancel={
          params?.view == true || params?.id
            ? () => {
                setCancelModalStatus(true);
                setItemData({
                  id: entryData?.transactionid,
                  nav: '/paymententries',
                  todo: 'cancel',
                  // linked: paymentTransID !== "",
                  from: 'Payment',
                  fn: () => cancel(entryData?.transactionid, entryData?.transactiontypecd, entryData?.vouchernumber),
                });
              }
            : null
        }
        onDelete={
          params?.view == true || params?.id
            ? () => {
                setDeleteItemModal(true);
                setItemData({
                  id: entryData?.transactionid,
                  label: 'Payment',
                  from: 'Payment',
                  nav: '/paymententries',
                  todo: 'delete',
                  fn: () => {
                    deleteEntry(itemData?.id);
                  },
                });
              }
            : null
        }
        onPreview={() => {
          setPreviewPaymentModal(true);
        }}
        onSaveNew={params?.view !== true ? () => saveChanges({ new: true }) : null}
        onReset={
          params?.view !== true
            ? () => {
                setState(initialState);
              }
            : null
        }
      />
      {/* ) : null} */}
      {deleteItemModal == true ? (
        // <DeletePaymentEntry
        //   open={deleteItemModal}
        //   setOpen={setDeleteItemModal}
        //   itemData={itemData}
        // />
        <InvoiceCancel
          state={state}
          setState={setState}
          open={deleteItemModal}
          setOpen={setDeleteItemModal}
          vouchers={vouchers}
          onConfirm={() => {
            deleteEntry(itemData);
            setDeleteItemModal(false);
          }}
          itemData={itemData}
        />
      ) : null}
      {cancelModalStatus == true ? (
        <InvoiceCancel
          state={state}
          vouchers={vouchers}
          setState={setState}
          open={cancelModalStatus}
          setOpen={setCancelModalStatus}
          itemData={itemData}
        />
      ) : null}
      <PreviewSalesTaxable open={previewPaymentModal} setOpen={setPreviewPaymentModal} getHtml={handlePrint} type={'payment'} />
      {linkToInvoiceModal === true && (
        <LinkToPurchaseInvoice
          open={linkToInvoiceModal}
          setOpen={setLinkToInvoiceModal}
          setTransArr={setTransArr}
          entryData={entryData}
          accountID={accountID}
          showWarningSnackbar={showWarningSnackbar}
          setLinkedData={setLinkedData}
          paymentDetails={state}
        />
      )}
      {openModalEvent === true && (
        // <CreateAndEditLedger  open={fromAccountModal} setOpen={setFromAccountModal} tab={"pay"} setData={setState}  />
        <AddAccountModal
          open={fromAccountModal}
          setOpen={setFromAccountModal}
          setData={setState}
          data={state}
          accountType={accountFlag === true ? (state.method === 'CashPayment' ? 'Cash' : 'Bank') : 'paidTo'}
          Type={'Payment'}
          companyData={companyDetail}
          setNewPartyName={setNewPartyName}
          newPartyName={newPartyName}
          setNewPartyID={setNewPartyID}
          newPartyID={newPartyID}
          setSelectedGroupId={setSelectedGroupId}
          selelctedGroupId={selelctedGroupId}
          // setAllAccount={setAccountName}
        />
      )}
      {openBankModal === true && (
        <AddBankAccountModal
          open={openBankModal}
          setOpen={setOpenBankModal}
          showSuccessSnackbar={showSuccessSnackbar}
          showWarningSnackbar={showWarningSnackbar}
          showErrorSnackbar={showErrorSnackbar}
          setData={setState}
          data={state}
          companyData={companyDetail}
          accountType={'Payment'}
        />
      )}
      {settingsModal === true && <NewVoucherSettingsModal open={settingsModal} label="Payment" type="Payment" setOpen={setSettingsModal} />}
      <ConfirmCancel open={cancelModal} setOpen={setCancelModal} path="paymententries" />
      {accountIDTransaction && (
        <LedgerTransactionModalv2
          open={accountIDTransaction}
          accountId={accountIDTransaction}
          onClose={() => setAccountIDTransaction('')}
        />
      )}

      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backdropOpen || isAccountMasterLoading || LoadingLastAccount}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <SummaryDialog data={SummaryData} onClose={() => onSaveComplete()} />
    </Box>
  );
}

export default memo(AddPaymentVoucher);
